/* eslint-disable no-sparse-arrays */
import { Query } from '@syncfusion/ej2-data';
import {
    GridComponent,
    QueryCellInfoEventArgs,
} from '@syncfusion/ej2-react-grids';
import { EditSettingsModel } from '@syncfusion/ej2-react-grids';
import * as React from 'react';
import Message from '../../utils/Message/Message';
import { AiOutlinePaperClip } from 'react-icons/ai';
import { BsSearch } from 'react-icons/bs';
import { GiDigDug } from 'react-icons/gi';
import {
    ButtonComponent,
    ChipListComponent
} from '@syncfusion/ej2-react-buttons';
import { ThemeContext } from '../../context/theme.context';
import { DropDownListComponent, MultiSelectComponent as MultiSelectC } from '@syncfusion/ej2-react-dropdowns';
import GlobalSearch from '../../components/GlobalSearch';
import GlobalGrid from '../../components/GlobalGrid';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {
    EditWorkOrder,
    GetMaxProntoRowIdData,
} from '../../services/CloudScheduler/CloudSchedulerServices';
import OrderAttachments from './OrderAttachments';
import { EditMassOrder, SendRequest } from '../../utils/CreateRequest';
import { addToQuery, applyTheRule } from '../../utils/BussinesRuleBuilder';
import { GetTablenameFromTask } from '../../utils/GetTablenameFromTask';
import GlobalDialog from '../../components/GlobalDialog';
import OperationTemplate from '../Settings/OperationTemplate/OperationTemplate';
import { useEffect, useState } from 'react';
import { getPriority } from '../../utils/GetPriorityColor';
import './style.css';
import { useDispatch, useSelector } from 'react-redux';
import {
    changeResetDataLoadingBoolenValue,
    setIsAppliedEventPlan,
    setIsBackendWorking,
    setIsGlobalDialogClosed,
    setIsPlanSelected,
    setIsWorkOrderDataChange,
    setSearchCaseGantt,
    setSearchCaseOp,
    setSearchCaseOrder,
} from '../../redux/search.slice';
import { GlobalDropDown, GlobalMultiSelection } from '../../components/GlobalDropDown';
import { getParamsDD } from '../../utils/GridParams';
import MassiveOrderEdit from '../../utils/MassOrderEdit';
import { all_information, loadingShow } from '../../App';
import { io } from 'socket.io-client';
import {
    EditMexListOperations,
    FetchNewMexRecordsOperations,
    SyncFromMex,
    SyncFullOperations,
} from '../../services/MexServices/Orders/OrderService';
import { AxiosResponse } from 'axios';
import { ButtonPropsModel } from '@syncfusion/ej2-react-popups';
import AssignWorkOrderDialog from './AssignWorkOrderDialog';
import { toast } from 'react-toastify';
import { usePreparingTemplatePoint } from '../../utils/OperationPreparingForTemplate';
import { GetBackendUrlForGlobalFunctions, GetErpTypeFromConfig } from '../../App';
import { DateRangePickerComponent, DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import {
    EditProntoOrders,
    SyncFromProntoApi,
    SyncFullProntoWorkOrders,
} from '../../services/ProntoServices/WorkOrderService/WorkOrderService';

import {
    convertToDate, excelQueryCellInfo,
    extractCharacters,
    extractNumbers,
    extractStringValue, groupTasksByDate, transformToMultiTableFormat,
} from '../../utils/Methods/methods';
import { MdAssignmentTurnedIn } from 'react-icons/md';

interface IProps {
    outter_asset_code?: string | undefined;
    noNeedFilterPanel?: boolean;
    gridRef?: (component: GridComponent) => void;
    multiSelection?: boolean;
    needDidMount: boolean;
    needExpandStatus?: boolean;
}

export let g_worder: string = '';
var mounted: boolean = false;
let checkFilterParams = true;
let selectedChips: Array<any> = [];
let selectedChipValues: Array<any> = [];
let departmentchips: Array<any> = [];
let theQueryScheduleNumber = '';
let theQueryStatuses = '';
let theQueryPrioritys = '';
let theQueryTeams = '';
let theQueryShifts = '';
let theQueryTrades = '';
let theQueryOPStatus = '';
let theQueryDepartment = '';
let theQuerySection = '';
let theQueryProntoReference = '';
let theQueryHoldReason = '';
let theQueryRevisionCode = '';
let theQueryAsset = '';
let theQueryParentAsset = '';
let theQueryOutterAsset = '';
let theQueryType = '';
let theQueryHasProblem = '';
let theQueryResp = '';
let theQueryDate = '';
let theQuerySearch = '';
let theQueryPlanId = '';
let theQueryWorkOrderCode = '';
let theQueryReference = '';
let buttonShiftAssignment: ButtonPropsModel[];
let buttonTeamAssignment: ButtonPropsModel[];
let chips: ChipListComponent = new ChipListComponent({});
let editOptions: EditSettingsModel = {
    allowEditing: true,
    allowAdding: false,
    allowDeleting: true,
    showDeleteConfirmDialog: true,
    mode: 'Batch',
    allowNextRowEdit: true,
};
let the_current_query = '';
let searchText: string = '';
let gridCPWorkorder: GridComponent;
let refreshTokens = [' ', '  ', '   ', '    '];
let isAgentAlive = false;
const WorkOrders = ({
                        outter_asset_code,
                        noNeedFilterPanel,
                        gridRef,
                        multiSelection,
                        needDidMount = false,
                        needExpandStatus = false,
                    }: IProps) => {
    const dispatch = useDispatch();
    let timezone_offset =
        -1 * useSelector((state: any) => state.search.timezone_offset);
    let gmt = useSelector((state: any) => state.search.server_gmt);
    let isAppliedEventPlan = useSelector(
        (state: any) => state.search.isAppliedEventPlan
    );
    let searchCase = useSelector((state: any) => state.search.searchCaseOperation);
    let dateTimePicker: DateTimePickerComponent = new DateTimePickerComponent({});
    const [defaultConfirmScheduleDate, setDefaultConfirmScheduleDate] = useState<Date | undefined>(undefined);
    const [hideSchedulerTimeDialog, setHideSchedulerTimeDialog] = useState(false);
    const { preparingTemplatePoint } = usePreparingTemplatePoint();
    const [refreshRequest, setrefreshRequest] = useState<string>('false');
    const [resetDataToastinId, setresetDataToastinId]: any = useState(null);
    const [isDataResettingComponentHandle, setisDataResettingComponentHandle] =
        useState<boolean>(false);
    const reduxSearchS = useSelector((state: any) => state.search);
    const isWorkOrderDataChange = useSelector(
        (state: any) => state.search.isWorkOrderDataChange
    );
    const isGlobalDialogClosed = useSelector(
        (state: any) => state.search.isGlobalDialogClosed
    );
    searchText = reduxSearchS.searchCaseOrder;
    const [commitToErpClicked, setcommitToErpClicked] = useState<boolean>(false);
    const [resetData, setResetData] = useState<boolean>(false);
    const [isResetDataLoading, setisResetDataLoading] = useState<boolean>(false);
    const [clickTimes, setClickTimes] = useState<number>(0);
    const ERP_TYPE = GetErpTypeFromConfig();
    const erpTypeName = 'MEX';
    const [questionDialog, setQuestionDialog] = useState(false);
    const [hideDialogEventPlan, setHideDialogEventPlan] = useState(false);
    const [hideShiftDialog, setHideShiftDialog] = useState(false);
    const [hideTeamDialog, setHideTeamDialog] = useState(false);
    const [hideAddDialog, setHideAddDialog] = useState(false);
    const [massiveEditDialog, setMassiveEditDialog] = useState(false);
    const [showTemplateDialog, setShowTemplateDialog] = useState(false);
    const [PriorityColorData, setPriorityColorData] = useState<Array<any>>([]);
    const [current_query, setCurrentQuery] = useState('');
    const [loadSignal, setLoadSignal] = useState(false);
    const [currentWOC, setCurrentWOC] = useState<string | undefined>(undefined);
    const [order_detail, setOrderDetail] = useState({
        order_code: undefined,
        order_id: undefined,
    });
    const [gridGetQuery, setGridGetQuery] = useState<string>('order');
    const server_gmt = useSelector((state: any) => state.search.server_gmt)
    const serverOffsetMillis = 60 * 1000 * -(server_gmt * 60);
    const localOffset = new Date().getTimezoneOffset();
    const localOffsetMillis = 60 * 1000 * localOffset;
    let dropDownListObjectShiftElment: DropDownListComponent;
    let dropDownListObjectTeamElment: DropDownListComponent;

    var moment = require('moment-timezone');
    const refreshGridFunction = () => {
        setLoadSignal(true);
        setrefreshRequest('true');
        gridCPWorkorder?.refresh();
    };

    const context = React.useContext(ThemeContext);
    const socket = io(GetBackendUrlForGlobalFunctions() as string, {
        autoConnect: false,
        transports: ['websocket'],
    });
    const [isFilterActive, setIsFilterActive] = useState(false);
    let buttonScheduler: ButtonPropsModel[] = [
        {
            click: async (args: any) => {
                await editOrders()
            },
            buttonModel: {
                content: 'Yes',
                isPrimary: true,
            },
        },
        {
            click: () => {
                setHideSchedulerTimeDialog(false);
            },
            buttonModel: {
                content: 'No',
                isPrimary: false,
            },
        },
    ];
    const editOrders = async () => {
        let datas = gridCPWorkorder.getSelectedRecords();
        if (datas.length > 0) {
            datas.map((item: any) => {
                delete item.materialStatus;
                delete item.tradeDescription;
                delete item.label;

                let date = dateTimePicker.value;
                if (date) {
                    item.scheduled_start_date = moment(date);
                }
            })
            setHideSchedulerTimeDialog(false);
            gridCPWorkorder.showSpinner()

            await EditMassOrder(
                datas,
                () => {
                },
                gmt
            );
            gridCPWorkorder.hideSpinner()

            loadingShow(false);
            Message.success('Success');
            refreshGridFunction();
            //getBusinessLogic();
        }
    }
    let confirmSchedulerTime = (event: any) => {
        if (event.value) {
            const newDate = new Date(event.value);
            newDate.setHours(6, 0, 0, 0);
            setDefaultConfirmScheduleDate(newDate);
        }
    };
    const [theDatas, setTheDatas] = useState<any[]>([]);
    let answer: boolean;
    let buttonsOrder: ButtonPropsModel[] = [
        {
            buttonModel: { content: 'All Data' },
            click: () => {
                answer = true;
                loadingShow(true, 'Waiting for fetch operations...');

                FetchNewMexRecordsOperations(timezone_offset)
                    .then((result: any) => {
                        if (result.status == 200) {
                            loadingShow(false);
                            if (result.data.length === 0) {
                                Message.success('There is no new record...');
                                refreshGridFunction();
                            } else {
                                Message.success(`Fetched records successfully...`);
                                refreshGridFunction();
                            }
                        }
                    })
                    .catch((err) => {
                        loadingShow(false);
                        Message.error('Fetching failed!!!');
                    });
                setQuestionDialog(false);
            },
        },
        {
            buttonModel: { content: 'Planned Data' },
            click: () => {
                answer = false;
                let thePlanID = Number(localStorage.getItem('cs_plan_dd_value'));
                if (thePlanID === 0) {
                    Message.error('Please select a plan...');
                } else {
                    loadingShow(true, 'Waiting for fetch operations...');
                    FetchNewMexRecordsOperations(timezone_offset, thePlanID)
                        .then((result: any) => {
                            if (result.status == 200) {
                                loadingShow(false);
                                if (result.data.length === 0) {
                                    Message.success('There is no new record...');
                                    refreshGridFunction();
                                } else {
                                    Message.success(`Fetched records successfully...`);
                                    refreshGridFunction();
                                }
                            }
                        })
                        .catch((err) => {
                            loadingShow(false);
                            Message.error('Fetching failed!!!');
                        });
                    setQuestionDialog(false);
                }
            },
        },
    ];
    let commitToErpButtonModel: ButtonPropsModel[] = [
        {
            buttonModel: { content: 'Yes' },
            click: async () => {
                Message.info('Committing to erp');
                if (gridCPWorkorder?.getSelectedRecords().length > 0) {
                    let theDatas: any = gridCPWorkorder?.getSelectedRecords();
                    theDatas.map((item: any) => {
                        item.scheduled_start_date = item?.scheduled_start_date?.toString();
                    });
                    await EditMexListOperations(theDatas, timezone_offset)
                        .then((result: AxiosResponse) => {
                            if (result.status == 200) {
                                loadingShow(false);
                                Message.success('Committed successfully...');
                            }
                        })
                        .catch((err) => {
                            loadingShow(false);
                            Message.error('Commit failed!!!');
                        });
                }

                // if (gridCPWorkorder?.getSelectedRecords().length > 0) {
                //     let theDatas = gridCPWorkorder?.getSelectedRecords();
                //     theDatas = theDatas.map((theData: any) => {
                //         return { ...theData, isEffected: false };
                //     });
                //     if (ERP_TYPE === 'MEX') {
                //         const differenceOffsetMillis =
                //             serverOffsetMillis - localOffsetMillis;
                //
                //         theDatas.map((item: any) => {
                //             item.scheduled_start_date = new Date(
                //                 new Date(item.scheduled_start_date)?.getTime() +
                //                 differenceOffsetMillis
                //             ).toString();
                //             item.scheduled_end_date = new Date(
                //                 new Date(item.scheduled_end_date)?.getTime() +
                //                 differenceOffsetMillis
                //             ).toString();
                //         });
                //     }
                //
                //     await EditWorkOrder(theDatas, -timezone_offset)
                //         .then((res) => {
                //             buildQuery(' ');
                //         })
                //         .catch((er) => {
                //             Message.error('Error occured');
                //         });
                // }
                setcommitToErpClicked(false);
            },
        },
        {
            buttonModel: { content: 'No' },
            click: () => {
                setcommitToErpClicked(false);
            },
        },
    ];
    const priorityColorChip = () => {
        return (
            // <div className='row md-6'>
            //   <ChipListComponent
            //     id='chip-filter-cp'
            //     selectedChips={selectedChipValues}
            //     selection='Multiple'
            //     ref={(el: ChipListComponent) => (chips = el)}
            //     click={isChipClicked2.bind(this)}
            //   >
            //     <ChipsDirective>
            //       {PriorityColorData.map((el: any, index: number) => {
            //         return (
            //           <ChipDirective
            //             text={`P${el.priority_code.trim()}`}
            //             cssClass={`e-chip-text${el.priority_code.trim()}`}
            //             key={index}
            //           />
            //         );
            //       })}
            //     </ChipsDirective>
            //   </ChipListComponent>
            // </div>
            <div></div>
        );
    };
    const resetDataFunction = () => {
        dispatch(changeResetDataLoadingBoolenValue());
        setResetData(false);
        SyncFullOperations()
            .then((result) => {
                if (result.status == 200) {
                    toast.update(resetDataToastinId, {
                        render: 'All is good',
                        type: 'success',
                        isLoading: false,
                    });
                    Message.success('Synced successfully...');
                    dispatch(changeResetDataLoadingBoolenValue());
                }
            })
            .catch((err) => {
                loadingShow(false);
                Message.error('Sync failed!!!');
            });
    };

    const shiftAssignment = async () => {
        let selectedElement = gridCPWorkorder.getSelectedRecords();

        if (
            dropDownListObjectShiftElment.value === undefined ||
            dropDownListObjectShiftElment.value === null
        ) {
            Message.error('You should select a shift');
            return;
        }

        if (selectedElement.length > 0) {
            loadingShow(true);

            selectedElement.map((item: any) => {
                if (dropDownListObjectShiftElment.value === -1) {
                    item.shift = null;
                } else {
                    item.shift = dropDownListObjectShiftElment.text;
                }
                item.shift = dropDownListObjectShiftElment.text;
                delete item.materialStatus;
                delete item.tradeDescription;
            });
            await EditMassOrder(
                selectedElement,
                () => {
                    Message.success('Shift Assigned Successfully');
                    loadingShow(false);
                    setHideShiftDialog(false);
                    refreshGridFunction();
                    buildQuery('');
                },
                gmt
            );
        }
    };

    const teamAssignment = async () => {
        let selectedElement = gridCPWorkorder.getSelectedRecords();

        if (
            dropDownListObjectTeamElment.value === undefined ||
            dropDownListObjectTeamElment.value === null
        ) {
            Message.error('You should select a team');
            return;
        }

        if (selectedElement.length > 0) {
            loadingShow(true);

            selectedElement.map((item: any) => {
                if (dropDownListObjectTeamElment.value === -1) {
                    item.team_code = null; 
                } else {
                    item.team_code = dropDownListObjectTeamElment.text;
                }
                item.team_code = dropDownListObjectTeamElment.text;
                delete item.materialStatus;
                delete item.tradeDescription;
            });
            await EditMassOrder(
                selectedElement,
                () => {
                    Message.success('Team Assigned Successfully');
                    loadingShow(false);
                    setHideTeamDialog(false);
                    refreshGridFunction();
                    buildQuery('');
                },
                gmt
            );
        }
    };

    const onShiftActionComplete = (e: any) => {
        if (e.name === 'actionComplete' && e.result) {
            const data = e.result.result ? e.result.result : e.result;
            const exists = data.some((x: any) => x.rosterId === -1);
            if (!exists) {
                data.unshift({ rosterCode: '', rosterId: -1, description: '' });
            }
        }
    };

    const onTeamActionComplete = (e: any) => {
        if (e.name === 'actionComplete' && e.result) {
            const data = e.result.result ? e.result.result : e.result;
            const exists = data.some((x: any) => x.team_id === -1);
            if (!exists) {
                data.unshift({ team_code: '', team_id: -1,  });
            }
        }
    };

    const isChipClicked2 = (e: any) => {
        if (e.selected) {
            selectedChips.push(e.index + 1);
            selectedChipValues.push(e.index);
        } else {
            selectedChips.splice(selectedChips.indexOf(e.index + 1), 1);
            selectedChipValues.splice(selectedChipValues.indexOf(e.index), 1);
        }
        buildQuery('');
    };
    const template = () => {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    alignSelf: 'flex-end',
                    height: 25,
                }}
            >
                <TextBoxComponent
                    type={'text'}
                    id='work_orders'
                    autocomplete='off'
                    input={inputEnterPress.bind(this)}
                    showClearButton
                    placeholder='Search'
                    value={searchText}
                    onChange={(args: any) => {
                        searchText = args.target.value;
                        dispatch(setSearchCaseOrder(searchText));
                    }}
                />
                <div
                    style={{
                        borderRightColor: 'transparent',
                        borderTopColor: 'transparent',
                        borderBottomColor: 'transparent',
                    }}
                >
                    <BsSearch
                        color={context.isDarkMode ? '#eaeaea' : '#292525'}
                        className={'searchIcon'}
                        onClick={search.bind(this)}
                    />
                </div>
            </div>
        );
    };

    const assignShiftButton = () => {
        return (
            <ButtonComponent
                onClick={() => {
                    let selectedElement = gridCPWorkorder?.getSelectedRecords?.() ?? [];

                    if (selectedElement.length > 0) {
                        setHideShiftDialog(true);
                    } else {
                        Message.error('Must selected a operation at least');
                    }
                }}
            >
                <MdAssignmentTurnedIn /> Shift Assign
            </ButtonComponent>
        );
    };

    const assignTeamButton = () => {
        return (
            <ButtonComponent
                onClick={() => {
                    let selectedElement = gridCPWorkorder?.getSelectedRecords?.() ?? [];

                    if (selectedElement.length > 0) {
                        setHideTeamDialog(true);
                    } else {
                        Message.error('Must selected a operation at least');
                    }
                }}
            >
                <MdAssignmentTurnedIn /> Team Assign
            </ButtonComponent>
        );
    };

    const contextMenuItems = [
        {
            text: 'View Order Attachments',
            tooltipText: 'view',
            prefixIcon: 'e-view',
            id: 'view',
        },
        {
            text: 'Show Materials',
            tooltipText: 'view',
            prefixIcon: 'e-view',
            id: 'materials',
        },
    ];

    buttonShiftAssignment = [
        {
            click: () => {
                shiftAssignment();
            },
            buttonModel: {
                content: 'Yes',
                isPrimary: true,
            },
        },
        {
            click: () => {
                setHideShiftDialog(false);
            },
            buttonModel: {
                content: 'No',
                isPrimary: false,
            },
        },
    ];

    buttonTeamAssignment = [
        {
            click: () => {
                teamAssignment();
            },
            buttonModel: {
                content: 'Yes',
                isPrimary: true,
            },
        },
        {
            click: () => {
                setHideTeamDialog(false);
            },
            buttonModel: {
                content: 'No',
                isPrimary: false,
            },
        },
    ];

    let priorityFMSComValue: Array<any> = [];
    let departmentFMSComValue: Array<any> = [];
    let sectionFMSComValue: Array<any> = [];
    let prontoReferenceFMSComValue: Array<any> = [];
    let holdReasonFMSComValue: Array<any> = [];
    let revisionCodeFMSComValue: Array<any> = [];
    let statusFMSComValue: Array<any> = [];
    let teamFMSComValue: Array<any> = [];
    let shiftFMSComValue: Array<any> = [];
    let tradeFMSComValue: Array<any> = [];
    let OPStatusFMSComValue: Array<any> = [];
    let typeFMSComValue: Array<any> = [];
    let hasProblemValue: Array<any> = [];

    let respFMSComValue: Array<any> = [];
    // let referenceFMSComValue: string = '';
    const [referenceFMSComValue, setreferenceFMSComValue] = useState<string>('');
    let workorderCodeFMSComValue: string = '';
    let ScheduleNumberFMSComValue: string = '';
    let assetFMSComValue: string = '';
    let parentAssetFMSComValue: string = '';
    let queryOfAsset = new Query().take(20);
    let statusFMSCom: MultiSelectC = new MultiSelectC({});
    let teamFMSCom: MultiSelectC = new MultiSelectC({});
    let shiftFMSCom: MultiSelectC = new MultiSelectC({});
    let tradeFMSCom: MultiSelectC = new MultiSelectC({});
    let OPStatusFMSCom: MultiSelectC = new MultiSelectC({});
    let schdeduleStartDateVal: any = '';
    let plannedStartDateVal: any = '';
    let departmentFMSCom: MultiSelectC = new MultiSelectC({});
    let sectionFMSCom: MultiSelectC = new MultiSelectC({});
    let prontoReferenceFMSCom: MultiSelectC = new MultiSelectC({});
    let holdReasonFMSCom: MultiSelectC = new MultiSelectC({});
    let revisionCodeFMSCom: MultiSelectC = new MultiSelectC({});
    let typeFMSCom: MultiSelectC = new MultiSelectC({});
    let hasProblem: MultiSelectC = new MultiSelectC({});
    let respFMSCom: MultiSelectC = new MultiSelectC({});
    let startDateFMSCom: any = null;
    let plannedStartDateFMSCom: any = null;
    let priorityFMSCom: MultiSelectC = new MultiSelectC({});
    let assetFMSCom: TextBoxComponent = new TextBoxComponent({});
    let parentAssetFMSCom: TextBoxComponent = new TextBoxComponent({});
    let referenceFMSCom: TextBoxComponent = new TextBoxComponent({});
    let workorderCodeFMSCom: TextBoxComponent = new TextBoxComponent({});
    let ScheduleNumberFMSCom: TextBoxComponent = new TextBoxComponent({});
    const inputEnterPress = (e: any) => {
        if (e.key === 'Enter' || e.keyCode === 13) {
            search();
        }
    };
    const buildQuery = (additionalQuery: string) => {
        the_current_query = the_current_query.trimEnd();

        the_current_query = the_current_query.replace(theQueryPrioritys, '');
        the_current_query = the_current_query.replace(theQueryTeams, '');
        the_current_query = the_current_query.replace(theQueryShifts, '');
        the_current_query = the_current_query.replace(theQueryTrades, '');
        the_current_query = the_current_query.replace(theQueryOPStatus, '');
        the_current_query = the_current_query.replace(theQueryAsset, '');
        the_current_query = the_current_query.replace(theQueryParentAsset, '');
        the_current_query = the_current_query.replace(theQueryOutterAsset, '');
        the_current_query = the_current_query.replace(theQueryDate, '');
        the_current_query = the_current_query.replace(theQueryResp, '');
        the_current_query = the_current_query.replace(theQueryStatuses, '');
        the_current_query = the_current_query.replace(theQueryType, '');
        the_current_query = the_current_query.replace(theQueryHasProblem, '');
        the_current_query = the_current_query.replace(theQuerySearch, '');
        the_current_query = the_current_query.replace(theQueryPlanId, '');
        the_current_query = the_current_query.replace(theQueryReference, '');
        the_current_query = the_current_query.replace(theQueryWorkOrderCode, '');
        the_current_query = the_current_query.replace(theQueryScheduleNumber, '');
        the_current_query = the_current_query.replace(theQueryDepartment, '');
        the_current_query = the_current_query.replace(theQuerySection, '');
        the_current_query = the_current_query.replace(theQueryProntoReference, '');
        the_current_query = the_current_query.replace(theQueryHoldReason, '');
        the_current_query = the_current_query.replace(theQueryRevisionCode, '');

        var o_asset_code = outter_asset_code;
        theQueryDepartment = '';
        theQuerySection = '';
        theQueryTeams = '';
        theQueryShifts = '';
        theQueryTrades = '';
        theQueryOPStatus = '';
        theQueryProntoReference = '';
        theQueryHoldReason = '';
        theQueryRevisionCode = '';
        theQueryPrioritys = '';
        theQueryStatuses = '';
        theQueryAsset = '';
        theQueryParentAsset = '';
        theQueryResp = '';
        theQueryType = '';
        theQueryHasProblem = '';
        theQueryDate = '';
        theQuerySearch = '';
        theQueryOutterAsset = '';
        theQueryReference = '';
        theQueryWorkOrderCode = '';
        theQueryScheduleNumber = '';

        var thePrioritysMerged = selectedChips.concat(priorityFMSComValue);
        var thePurePrioritys = [...new Set(thePrioritysMerged)];
        var thePrioritys = thePurePrioritys?.toString();

        var theDepartment = departmentFMSCom?.value?.toString();
        var theSection = sectionFMSCom?.value?.toString();
        var theProntoReference = prontoReferenceFMSCom?.value?.toString();
        var theHoldReason = holdReasonFMSCom?.value?.toString();
        var theRevisionCode = revisionCodeFMSCom?.value?.toString();

        var theStatuses = statusFMSCom?.value?.toString();

        var theTeams = teamFMSCom?.value?.toString();
        var theShifts = shiftFMSCom?.value?.toString();
        var theTrades = tradeFMSCom?.value?.toString();
        var theOPStatus = OPStatusFMSCom?.value?.toString();

        var theTypes = typeFMSCom?.value?.toString();
        var theHasproblem = hasProblem?.value?.toString();
        var theResp = respFMSCom?.value?.toString();

        var theReference = referenceFMSCom?.value?.toString();
        var theworkorderCode = workorderCodeFMSCom?.value?.toString();
        var theScheduleNumber = ScheduleNumberFMSCom?.value?.toString();

        var theDate = schdeduleStartDateVal;
        var thePlannedDate = plannedStartDateVal;
        var theAssets = assetFMSCom?.value?.toString();
        var theparentAssets = parentAssetFMSCom?.value?.toString();

        if (checkFilterParams) {
            if (theScheduleNumber === '' || theScheduleNumber === undefined) {
                var theScheduleNumberFromLocalStorage = localStorage.getItem(
                    'textboxPMSchedulerNumberTextComponent'
                );
                if (theScheduleNumberFromLocalStorage) {
                    theScheduleNumber = extractNumbers(theScheduleNumberFromLocalStorage);
                }
            }

            if (theScheduleNumber !== '' && theScheduleNumber !== undefined) {
                if (the_current_query !== '') {
                    theQueryScheduleNumber = addToQuery(
                        'pm_schedule_number',
                        'in',
                        'andWhere',
                        theScheduleNumber?.toString()
                    );
                } else {
                    theQueryScheduleNumber = addToQuery(
                        'pm_schedule_number',
                        'in',
                        'where',
                        theScheduleNumber?.toString()
                    );
                }
                the_current_query += theQueryScheduleNumber;
            }

            if (theworkorderCode === '' || theworkorderCode === undefined) {
                var theScheduleWorkorderFromLocalStorage = localStorage.getItem(
                    'textboxWorkOrderTextBox'
                );
                if (theScheduleWorkorderFromLocalStorage) {
                    theworkorderCode = extractNumbers(
                        theScheduleWorkorderFromLocalStorage
                    );
                }
            }

            if (theworkorderCode !== '' && theworkorderCode !== undefined) {
                if (the_current_query !== '') {
                    theQueryWorkOrderCode = addToQuery(
                        'order_code',
                        'in',
                        'andWhere',
                        theworkorderCode?.toString()
                    );
                } else {
                    theQueryWorkOrderCode = addToQuery(
                        'order_code',
                        'in',
                        'where',
                        theworkorderCode?.toString()
                    );
                }
                the_current_query += theQueryWorkOrderCode;
            }

            if (theDepartment == '' || theDepartment == undefined) {
                var thDepartmentFromLocalStorage = localStorage.getItem(
                    'multiselectDepartmentordersFilterMultiPriority'
                );
                var thDepartmentFromLocalStorageString = extractCharacters(
                    thDepartmentFromLocalStorage
                ).join(',');
                theDepartment = thDepartmentFromLocalStorageString;
            }

            if (theDepartment !== '' && theDepartment !== undefined) {
                if (ERP_TYPE === erpTypeName) {
                    if (the_current_query !== '') {
                        theQueryDepartment = addToQuery(
                            'department_id',
                            'in',
                            'andWhere',
                            theDepartment?.toString()
                        );
                    } else {
                        theQueryDepartment = addToQuery(
                            'department_id',
                            'in',
                            'where',
                            theDepartment?.toString()
                        );
                    }
                } else {
                    if (the_current_query !== '') {
                        theQueryDepartment = addToQuery(
                            'order_branch',
                            'in',
                            'andWhere',
                            theDepartment?.toString()
                        );
                    } else {
                        theQueryDepartment = addToQuery(
                            'order_branch',
                            'in',
                            'where',
                            theDepartment?.toString()
                        );
                    }
                }
                the_current_query += theQueryDepartment;
            }
            if (theSection !== '' && theSection !== undefined) {
                if (the_current_query !== '') {
                    theQuerySection = addToQuery(
                        'order_section_code',
                        'in',
                        'andWhere',
                        theSection?.toString()
                    );
                } else {
                    theQuerySection = addToQuery(
                        'order_section_code',
                        'in',
                        'where',
                        theSection?.toString()
                    );
                }
                the_current_query += theQuerySection;
            }
            if (theProntoReference !== '' && theProntoReference !== undefined) {
                if (the_current_query !== '') {
                    theQueryProntoReference = addToQuery(
                        'site_details_1',
                        'in',
                        'andWhere',
                        theProntoReference?.toString()
                    );
                } else {
                    theQueryProntoReference = addToQuery(
                        'site_details_1',
                        'in',
                        'where',
                        theProntoReference?.toString()
                    );
                }
                the_current_query += theQueryProntoReference;
            }
            if (theHoldReason !== '' && theProntoReference !== undefined) {
                if (the_current_query !== '') {
                    theQueryHoldReason = addToQuery(
                        'reason',
                        'in',
                        'andWhere',
                        theHoldReason!.toString()
                    );
                } else {
                    theQueryHoldReason = addToQuery(
                        'reason',
                        'in',
                        'where',
                        theHoldReason!.toString()
                    );
                }
                the_current_query += theQueryHoldReason;
            }
            if (theRevisionCode !== '' && theProntoReference !== undefined) {
                if (the_current_query !== '') {
                    theQueryRevisionCode = addToQuery(
                        'revision_code',
                        'in',
                        'andWhere',
                        theRevisionCode!.toString()
                    );
                } else {
                    theQueryRevisionCode = addToQuery(
                        'revision_code',
                        'in',
                        'where',
                        theRevisionCode!.toString()
                    );
                }
                the_current_query += theQueryRevisionCode;
            }
            if (thePrioritys == '' || thePrioritys == undefined) {
                var thPriorityFromLocalStorage = localStorage.getItem(
                    'multiselectordersFilterMultiPriority'
                );
                var thPriorityFromLocalStorageString = extractCharacters(
                    thPriorityFromLocalStorage
                ).join(',');
                thePrioritys = thPriorityFromLocalStorageString;
            }
            if (thePrioritys !== '' && thePrioritys !== undefined) {
                if (the_current_query !== '') {
                    theQueryPrioritys = addToQuery(
                        'priority_code',
                        'in',
                        'andWhere',
                        thePrioritys?.toString()
                    );
                } else {
                    theQueryPrioritys = addToQuery(
                        'priority_code',
                        'in',
                        'where',
                        thePrioritys?.toString()
                    );
                }
                the_current_query += theQueryPrioritys;
            }

            if (theTeams == '' || theTeams == undefined) {
                var thTeamFromLocalStorage = localStorage.getItem(
                    'multiselectordersFilterMultiTeam'
                );
                var thTeamFromLocalStorageString = extractCharacters(
                    thTeamFromLocalStorage
                ).join(',');
                theTeams = thTeamFromLocalStorageString;
            }
            if (theTeams !== '' && theTeams !== undefined) {
                if (the_current_query !== '') {
                    theQueryTeams = addToQuery(
                        'team_code',
                        'in',
                        'andWhere',
                        theTeams?.toString()
                    );
                } else {
                    theQueryTeams = addToQuery(
                        'team_code',
                        'in',
                        'where',
                        theTeams?.toString()
                    );
                }
                the_current_query += theQueryTeams;
            }

            if (theShifts == '' || theShifts == undefined) {
                var thShiftFromLocalStorage = localStorage.getItem(
                    'multiselectordersFilterMultiShift'
                );
                var thShiftFromLocalStorageString = extractCharacters(
                    thShiftFromLocalStorage
                ).join(',');
                theShifts = thShiftFromLocalStorageString;
            }
            if (theShifts !== '' && theShifts !== undefined) {
                if (the_current_query !== '') {
                    theQueryShifts = addToQuery(
                        'shift',
                        'in',
                        'andWhere',
                        theShifts?.toString()
                    );
                } else {
                    theQueryShifts = addToQuery(
                        'shift',
                        'in',
                        'where',
                        theShifts?.toString()
                    );
                }
                the_current_query += theQueryShifts;
            }
            // if (theTrades == '' || theTrades == undefined) {
            //     var thTradeFromLocalStorage = localStorage.getItem(
            //         'multiselectordersFilterMultiTrade'
            //     );
            //     var thTradeFromLocalStorageString = extractCharacters(
            //         thTradeFromLocalStorage
            //     ).join(',');
            //     theTrades = thTradeFromLocalStorageString;
            // }
            // if (theTrades !== '' && theTrades !== undefined) {
            //     if (the_current_query !== '') {
            //         theQueryTrades = addToQuery(
            //             'tradeCode',
            //             'in',
            //             'andWhere',
            //             theTrades?.toString()
            //         );
            //     } else {
            //         theQueryTrades = addToQuery(
            //             'tradeCode',
            //             'in',
            //             'where',
            //             theTrades?.toString()
            //         );
            //     }
            //     the_current_query += theQueryTrades;
            // }
            if (theOPStatus == '' || theOPStatus == undefined) {
                var thOPStatusFromLocalStorage = localStorage.getItem(
                    'multiselectordersFilterMultiOPStatus'
                );
                var thOPStatusFromLocalStorageString = extractCharacters(
                    thOPStatusFromLocalStorage
                ).join(',');
                theOPStatus = thOPStatusFromLocalStorageString;
            }
            if (theOPStatus !== '' && theOPStatus !== undefined) {
                if (the_current_query !== '') {
                    theQueryOPStatus = addToQuery(
                        'statusCode',
                        'in',
                        'andWhere',
                        theOPStatus?.toString()
                    );
                } else {
                    theQueryOPStatus = addToQuery(
                        'statusCode',
                        'in',
                        'where',
                        theOPStatus?.toString()
                    );
                }
                the_current_query += theQueryOPStatus;
            }


            if (theStatuses == '' || theStatuses == undefined) {
                var thStatusFromLocalStorage = localStorage.getItem(
                    'multiselectordersFilterMultiStatus'
                );
                var thStatusFromLocalStorageString = extractCharacters(
                    thStatusFromLocalStorage
                ).join(',');
                theStatuses = thStatusFromLocalStorageString;
            }
            if (erpTypeName === ERP_TYPE) {
                if (theStatuses !== '' && theStatuses !== undefined) {
                    if (the_current_query !== '') {
                        theQueryStatuses = addToQuery(
                            'status_id',
                            'in',
                            'andWhere',
                            theStatuses?.toString()
                        );
                    } else {
                        theQueryStatuses = addToQuery(
                            'status_id',
                            'in',
                            'where',
                            theStatuses?.toString()
                        );
                    }
                    the_current_query += theQueryStatuses;
                }
            } else {
                if (theStatuses !== '' && theStatuses !== undefined) {
                    if (the_current_query !== '') {
                        theQueryStatuses = addToQuery(
                            'status_id',
                            'in',
                            'andWhere',
                            theStatuses?.toString()
                        );
                    } else {
                        theQueryStatuses = addToQuery(
                            'status_id',
                            'in',
                            'where',
                            theStatuses?.toString()
                        );
                    }
                    the_current_query += theQueryStatuses;
                }
            }

            if (theAssets === '' || theAssets === undefined) {
                var theAssetFromLocalStorage = localStorage.getItem(
                    'textboxAssetTextBox'
                );
                if (theAssetFromLocalStorage) {
                    theAssets = extractStringValue(theAssetFromLocalStorage);
                }
            }
            if (theAssets !== '' && theAssets !== undefined) {
                if (the_current_query !== '') {
                    theQueryAsset = addToQuery(
                        'asset_code',
                        'in',
                        'andWhere',
                        theAssets?.toString()
                    );
                } else {
                    theQueryAsset = addToQuery(
                        'asset_code',
                        'in',
                        'where',
                        theAssets?.toString()
                    );
                }
                the_current_query += theQueryAsset;
            }

            if (theparentAssets === '' || theparentAssets === undefined) {
                var theParentAssetFromLocalStorage = localStorage.getItem(
                    'textboxParentAssetTextBox'
                );
                if (theParentAssetFromLocalStorage) {
                    theparentAssets = extractStringValue(theParentAssetFromLocalStorage);
                }
            }
            if (theparentAssets !== '' && theparentAssets !== undefined) {
                if (the_current_query !== '') {
                    theQueryParentAsset = addToQuery(
                        'asset_code_parent',
                        'in',
                        'andWhere',
                        theparentAssets?.toString()
                    );
                } else {
                    theQueryParentAsset = addToQuery(
                        'asset_code_parent',
                        'in',
                        'where',
                        theparentAssets?.toString()
                    );
                }
                the_current_query += theQueryParentAsset;
            }
            if (theTypes == '' || theTypes == undefined) {
                var theTypeFromLocalStorage = localStorage.getItem(
                    'multiselectoperationFilterMultiType'
                );
                var theTypeFromLocalStorageString = extractCharacters(
                    theTypeFromLocalStorage
                ).join(',');
                theTypes = theTypeFromLocalStorageString;
            }
            if (erpTypeName === ERP_TYPE) {
                if (theTypes !== '' && theTypes !== undefined) {
                    if (the_current_query !== '') {
                        theQueryType = addToQuery(
                            'type_id',
                            'in',
                            'where',
                            theTypes?.toString()
                        );
                    } else {
                        theQueryType = addToQuery(
                            'type_id',
                            'in',
                            'where',
                            theTypes?.toString()
                        );
                    }

                    the_current_query += theQueryType;
                }
            } else {
                if (theTypes !== '' && theTypes !== undefined) {
                    if (the_current_query !== '') {
                        theQueryType = addToQuery(
                            'type_code',
                            'in',
                            'andWhere',
                            theTypes?.toString()
                        );
                    } else {
                        theQueryType = addToQuery(
                            'type_code',
                            'in',
                            'where',
                            theTypes?.toString()
                        );
                    }
                    the_current_query += theQueryType;
                }
            }

            if (theResp !== '' && theResp !== undefined) {
                if (the_current_query !== '') {
                    theQueryResp = addToQuery(
                        'order_resp_code',
                        'in',
                        'andWhere',
                        theResp?.toString()
                    );
                } else {
                    theQueryResp = addToQuery(
                        'order_resp_code',
                        'in',
                        'where',
                        theResp?.toString()
                    );
                }
                the_current_query += theQueryResp;
            }
            if (theReference === '' || theReference === undefined) {
                var theReferenceFromLocalStorage = localStorage.getItem(
                    'textboxReferenceTextBox'
                );
                if (theReferenceFromLocalStorage) {
                    theReference = extractStringValue(theReferenceFromLocalStorage);
                }
            }

            if (theReference !== '' && theReference !== undefined) {
                if (the_current_query !== '') {
                    theQueryReference = addToQuery(
                        'site_details_1',
                        'in',
                        'andWhere',
                        theReference?.toString()
                    );
                } else {
                    theQueryReference = addToQuery(
                        'site_details_1',
                        'in',
                        'where',
                        theReference?.toString()
                    );
                }
                the_current_query += theQueryReference;
            }
            if (theDate == '' || theDate == undefined) {
                var theScheduleStartDateFromLocalStorage = localStorage.getItem(
                    'daterangepickerScheduleStartDateFilter'
                );
                if (theScheduleStartDateFromLocalStorage) {
                    const parsedData = JSON.parse(theScheduleStartDateFromLocalStorage);
                    if (parsedData.startDate && parsedData.endDate && parsedData.value) {
                        theDate = convertToDate({
                            startDate: parsedData.startDate,
                            endDate: parsedData.endDate,
                            value: parsedData.value,
                        });
                    }
                }
            }
            if (theDate !== '' && theDate && theDate !== undefined) {
                if (theDate.length > 0) {
                    if (the_current_query !== '') {
                        // var start_date = moment(theDate[0]).format('yyyy-MM-DD');
                        // var end_date = moment(theDate[1]).format('yyyy-MM-DD');
                        var start_date: string;
                        var end_date: string;
                        if (ERP_TYPE === erpTypeName) {
                            start_date = new Date(
                                new Date(theDate[0]).getTime() -
                                600 * 60 * 1000 -
                                new Date().getTimezoneOffset() * 60 * 1000
                            ).toISOString();

                            end_date = new Date(
                                new Date(theDate[1].setHours(13, 59, 59)).getTime() -
                                new Date().getTimezoneOffset() * 60 * 1000
                            ).toISOString();
                        } else {
                            start_date = moment(theDate[0]).format('yyyy-MM-DD');
                            end_date = moment(theDate[1]).format('yyyy-MM-DD') + 'T23:59:59.000Z';
                        }

                        theQueryDate = addToQuery(
                            'scheduled_start_date',
                            '>=',
                            'andWhere',
                            start_date
                        );
                        theQueryDate += addToQuery(
                            'scheduled_start_date',
                            '<=',
                            'andWhere',
                            end_date
                        );
                    } else {
                        // var start_date = moment(theDate[0]).format('yyyy-MM-DD');
                        // var end_date = moment(theDate[1]).format('yyyy-MM-DD');
                        var start_date: string;
                        var end_date: string;
                        if (ERP_TYPE === erpTypeName) {
                            start_date = new Date(
                                new Date(theDate[0]).getTime() -
                                600 * 60 * 1000 -
                                new Date().getTimezoneOffset() * 60 * 1000
                            ).toISOString();

                            end_date = new Date(
                                new Date(theDate[1].setHours(13, 59, 59)).getTime() -
                                new Date().getTimezoneOffset() * 60 * 1000
                            ).toISOString();
                        } else {
                            start_date = moment(theDate[0]).format('yyyy-MM-DD');
                            end_date = moment(theDate[1]).format('yyyy-MM-DD') + 'T23:59:59.000Z';
                        }

                        theQueryDate = addToQuery(
                            'scheduled_start_date',
                            '>=',
                            'where',
                            start_date
                        );
                        theQueryDate += addToQuery(
                            'scheduled_start_date',
                            '<=',
                            'andWhere',
                            end_date
                        );
                    }
                    the_current_query += theQueryDate;
                }
            }

            if (thePlannedDate == '' || thePlannedDate == undefined) {
                var thePlannedStartDateFromLocalStorage = localStorage.getItem(
                    'daterangepickerPlannedStartDateFilter'
                );
                if (thePlannedStartDateFromLocalStorage) {
                    const parsedData = JSON.parse(thePlannedStartDateFromLocalStorage);
                    if (parsedData.startDate && parsedData.endDate && parsedData.value) {
                        thePlannedDate = convertToDate({
                            startDate: parsedData.startDate,
                            endDate: parsedData.endDate,
                            value: parsedData.value,
                        });
                    }
                }
            }
            if (thePlannedDate !== '' && thePlannedDate && thePlannedDate !== undefined) {
                if (thePlannedDate.length > 0) {
                    if (the_current_query !== '') {
                        var start_date: string;
                        var end_date: string;
                        if (ERP_TYPE === erpTypeName) {
                            start_date = new Date(
                                new Date(thePlannedDate[0]).getTime() -
                                600 * 60 * 1000 -
                                new Date().getTimezoneOffset() * 60 * 1000
                            ).toISOString();

                            end_date = new Date(
                                new Date(thePlannedDate[1].setHours(13, 59, 59)).getTime() -
                                new Date().getTimezoneOffset() * 60 * 1000
                            ).toISOString();
                        } else {
                            start_date = moment(thePlannedDate[0]).format('yyyy-MM-DD');
                            end_date = moment(thePlannedDate[1]).format('yyyy-MM-DD') + 'T23:59:59.000Z';
                        }

                        theQueryDate = addToQuery(
                            'planned_start_date',
                            '>=',
                            'andWhere',
                            start_date
                        );
                        theQueryDate += addToQuery(
                            'planned_start_date',
                            '<=',
                            'andWhere',
                            end_date
                        );
                    } else {
                        var start_date: string;
                        var end_date: string;
                        if (ERP_TYPE === erpTypeName) {
                            start_date = new Date(
                                new Date(thePlannedDate[0]).getTime() -
                                600 * 60 * 1000 -
                                new Date().getTimezoneOffset() * 60 * 1000
                            ).toISOString();

                            end_date = new Date(
                                new Date(thePlannedDate[1].setHours(13, 59, 59)).getTime() -
                                new Date().getTimezoneOffset() * 60 * 1000
                            ).toISOString();
                        } else {
                            start_date = moment(thePlannedDate[0]).format('yyyy-MM-DD');
                            end_date = moment(thePlannedDate[1]).format('yyyy-MM-DD') + 'T23:59:59.000Z';
                        }

                        theQueryDate = addToQuery(
                            'planned_start_date',
                            '>=',
                            'where',
                            start_date
                        );
                        theQueryDate += addToQuery(
                            'planned_start_date',
                            '<=',
                            'andWhere',
                            end_date
                        );
                    }
                    the_current_query += theQueryDate;
                }
            }

            if (o_asset_code !== '' && o_asset_code !== undefined) {
                if (the_current_query !== '') {
                    theQueryOutterAsset = addToQuery(
                        'asset_code',
                        'in',
                        'andWhere',
                        o_asset_code.trim()
                    );
                } else {
                    theQueryOutterAsset = addToQuery(
                        'asset_code',
                        'in',
                        'where',
                        o_asset_code.trim()
                    );
                }
                the_current_query += theQueryOutterAsset;
            }

            if (theHasproblem == '' || theHasproblem == undefined) {
                var theHasproblemfromLocalStorage = localStorage.getItem(
                    'multiselecthasProblemFilterMulti'
                );
                var theHasproblemfromLocalStorageString = extractCharacters(
                    theHasproblemfromLocalStorage
                ).join(',');
                theHasproblem = theHasproblemfromLocalStorageString;
            }

            if (theHasproblem !== '' && theHasproblem !== undefined) {
                if (the_current_query !== '') {
                    theQueryHasProblem = addToQuery(
                        'has_operation',
                        'in',
                        'andWhere',
                        theHasproblem?.toString()
                    );
                } else {
                    theQueryHasProblem = addToQuery(
                        'has_operation',
                        'in',
                        'where',
                        theHasproblem?.toString()
                    );
                }
                the_current_query += theQueryHasProblem;
            }
        }
        if (reduxSearchS.planId !== 0) {
            if (the_current_query !== '') {
                theQueryPlanId = addToQuery(
                    'ID',
                    '=',
                    'andWhere',
                    reduxSearchS.planId?.toString()
                );
            } else {
                theQueryPlanId = addToQuery(
                    'ID',
                    '=',
                    'where',
                    reduxSearchS.planId?.toString()
                );
            }
            the_current_query += theQueryPlanId;
        }
        if (searchText !== '' && searchText) {
            theQuerySearch = '$' + searchText;
            the_current_query = the_current_query + theQuerySearch;
        }

        setLoadSignal(true);
        setCurrentQuery(the_current_query + ' ' + additionalQuery);
        dispatch(
            setIsPlanSelected({
                isOrderPlanSelected: false,
                isOpPlanSelected: reduxSearchS.isOpPlanSelected,
                planId: reduxSearchS.planId,
            })
        );
        // dispatch(setSearchCaseOrder(''));
        checkFilterParams = true;

        const filterParts = [
            theQueryPrioritys,
            theQueryTeams,
            theQueryShifts,
            theQueryTrades,
            theQueryOPStatus,
            theQueryDepartment,
            theQuerySection,
            theQueryProntoReference,
            theQueryHoldReason,
            theQueryRevisionCode,
            theQueryStatuses,
            theQueryAsset,
            theQueryParentAsset,
            theQueryOutterAsset,
            theQueryType,
            theQueryHasProblem,
            theQueryResp,
            theQueryDate,
            theQueryReference,
            theQueryWorkOrderCode,
            theQueryScheduleNumber
        ];

        const filterActive = filterParts.some(q => q && q.trim() !== "");

        setIsFilterActive(filterActive);
        localStorage.setItem("isFilterActive", JSON.stringify(filterActive));
    };

    const search = () => {
        if (searchText === '') {
            dispatch(setSearchCaseOrder(''));
        }
        if (searchText !== '' || current_query !== '') {
            buildQuery('');
        }
    };
    const excelExportsColumns: any = [
        { field: 'WorkOrderDescription', headerText: '', width: 300 },
        { field: 'scheduled_start_date', headerText: 'Sched. Date', width: 100 },
        { field: 'asset_code', headerText: 'Plant Item', width: 80 },
        { field: 'asset_description', headerText: 'Plant Description', width: 100 },
        { field: 'order_code', headerText: 'W/O #', width: 80 },
        { field: 'description', headerText: 'Work Order Description', width: 400 },
        { field: 'pm_schedule_id', headerText: 'PM Task', width: 80 },
        { field: 'type_code', headerText: 'Type', width: 80 },
        { field: 'site_details_1', headerText: 'Reference', width: 80 },
        { field: 'reason', headerText: 'Hold Reason', width: 80 },
        { field: 'order_resp_code', headerText: 'Resp', width: 80 },
        { field: 'priority_code', headerText: 'Priority', width: 80 },
        { field: 'team_code', headerText: 'uWork Team', width: 80 },
        { field: 'shift', headerText: 'uWork Shift', width: 80 },
        { field: 'tradeCode', headerText: 'Lab.', width: 80 },
        { field: 'required', headerText: 'Qty.', width: 80 },
        { field: 'estHours', headerText: 'Hrs', width: 80 },
        { field: 'section', headerText: 'Section', width: 80 },
        { field: 'plannedBy', headerText: 'Plan By', width: 80 },
    ];
    const toolbarClickExtends = async (args: any) => {
        if (args.item.id === 'refresh') {
            /* setLoadSignal(true); */
            refreshGridFunction();
        }
        if (args.item.id === 'ExcelExport') {
            const gridData: Array<any> = gridCPWorkorder?.currentViewData;
            gridData?.map((row: any) => {
                row.scheduled_start_date = row.scheduled_start_date
                    .toLocaleString()
                    .replace(/:\d{2}$/, "");
            });

            const grouped = groupTasksByDate(gridData);
            const transformed = transformToMultiTableFormat(grouped);
            args.data = transformed;

            gridCPWorkorder.excelExport({
                dataSource: transformed,
                columns: excelExportsColumns,
            });
        }
        if (args.item.id === 'scheduler') {
            if (gridCPWorkorder?.selectionModule?.getSelectedRecords().length !== 0) {
                setHideSchedulerTimeDialog(true);
            } else {
                Message.error('No records selected to Assign');
            }
        }
        if (args.item.id === 'update_pronto_api') {
            if (gridCPWorkorder?.getSelectedRecords().length > 0) {
                let theDatas = JSON.parse(JSON.stringify(gridCPWorkorder?.getSelectedRecords()));
                dispatch(setIsBackendWorking(true));
                //gridCPWorkorder.showSpinner();
                gridCPWorkorder.clearRowSelection();

                await EditProntoOrders(theDatas)
                    .then((result: AxiosResponse) => {
                        //gridCPWorkorder.hideSpinner();
                        if (result.data.status == 200) {
                            //loadingShow(false);
                            Message.success(`${result.data.message}...`);
                        }
                        if (result.data.status == 401 || result.data.status == 500) {
                            loadingShow(false);
                            Message.error(`${result.data.message}...`);
                        }
                        //buildQuery('');

                        //dispatch(setIsBackendWorking(false));
                    })
                    .catch((err) => {
                        dispatch(setIsBackendWorking(false));
                        //loadingShow(false);
                        Message.error('Update failed!!!');
                    });
                dispatch(setIsBackendWorking(false));
            } else {
                Message.error('Select an order!!!');
            }
        }

        if (args.item.id === 'reset_pronto_data') {
            if (gridCPWorkorder?.getSelectedRecords().length > 0) {
                let theTableName = await GetTablenameFromTask('ORDERS');
                if (theTableName === '') {
                    theTableName = 'job5mfj';
                } else {
                    theTableName = theTableName.trim();
                    let theValue = theTableName.split(' ');
                    theTableName = theValue[theValue.length - 1];
                }
                let theRowIds = gridCPWorkorder
                    .getSelectedRecords()
                    .map((x: any) => x.pronto_row_id)
                    .toString();
                let theQuery = `Select *
                                from ${theTableName}
                                where job5mfj.row_id in (${theRowIds});`;
                Message.info('Please wait for the response. It may take a while');
                let count: number = 11;
                let interval = setInterval(() => {
                    count--;
                    //  loadingShow(true, 'Checking... ' + count + ' seconds');
                    if (count === 0) {
                        clearInterval(interval);
                        isAgentAlive = false;
                        // Message.info('No response to procced. Please try again later.');
                        // Message.error(
                        //     'Windows Agent is not currently available, please contact system administrator.'
                        // );
                        loadingShow(false);
                    }
                    if (isAgentAlive) {
                        clearInterval(interval);
                        isAgentAlive = false;
                        loadingShow(false);
                    }
                }, 1000);
                SendRequest(theQuery, 'RESET DATA', undefined, true);
            } else {
                Message.info('Select order');
            }
        }
        if (args.item.id === 'deleted_orders') {
            SendRequest('', 'DELETED_ORDERS_REMOVED', undefined, true);

        }
        if (args.item.id === 'sync_from_erp') {
            if (gridCPWorkorder?.getSelectedRecords().length > 0) {
                let theRowIds: string = '';
                let theQuery: string = '';
                if (ERP_TYPE === erpTypeName) {
                    theRowIds = gridCPWorkorder
                        .getSelectedRecords()
                        .map((x: any) => x.order_code)
                        .toString();
                    theQuery = `Select *
                                from WorkOrder
                                where WorkOrder.WorkOrderNumber in (${theRowIds});`;
                } else {
                    theRowIds = gridCPWorkorder
                        .getSelectedRecords()
                        .map((x: any) => x.pronto_row_id)
                        .toString();
                    theQuery = `Select *
                                from job5mfj
                                where job5mfj.row_id in (${theRowIds});`;
                }


                Message.info('Please wait for the response. It may take a while');
                let count: number = 11;
                let interval = setInterval(() => {
                    count--;
                    //loadingShow(true, 'Checking... ' + count + ' seconds');
                    if (count === 0) {
                        clearInterval(interval);
                        isAgentAlive = false;
                        Message.info('No response to procced. Please try again later.');
                        Message.error(
                            'Windows Agent is not currently available, please contact system administrator.'
                        );
                        loadingShow(false);
                    }
                    if (isAgentAlive) {
                        clearInterval(interval);
                        isAgentAlive = false;
                        loadingShow(false);
                    }
                }, 1000);
                SendRequest(theQuery, 'SYNCED', undefined, true);
            } else {
                Message.info('Select order');
            }
        }

        if (args.item.id === 'sync_from_pronto_api') {
            if (gridCPWorkorder?.getSelectedRecords().length === 1) {
                let theDatas: any = gridCPWorkorder?.getSelectedRecords();
                loadingShow(true, 'Loading...');
                let orderCode = theDatas[0].order_code;
                SyncFromProntoApi(orderCode)
                    .then((result: AxiosResponse) => {
                        if (result.status == 200) {
                            loadingShow(false);
                            Message.success('Synced successfully...');
                            buildQuery('');
                        }
                    })
                    .catch((err) => {
                        loadingShow(false);
                        Message.error('Sync failed!!!');
                    });
            } else {
                Message.error('One order allowed only!!!');
            }
        }
        if (args.item.id === 'sync_from_mex') {
            if (gridCPWorkorder?.getSelectedRecords().length > 0) {
                let theDatas: any = gridCPWorkorder?.getSelectedRecords();

                theDatas.map((item: any) => {
                    item.scheduled_start_date = item?.scheduled_start_date?.toString();
                });
                loadingShow(true, 'Loading...');

                await SyncFromMex(theDatas, timezone_offset)
                    .then((result: AxiosResponse) => {
                        if (result.status == 200) {
                            loadingShow(false);
                            Message.success('Synced successfully...');
                            buildQuery('');
                        }
                    })
                    .catch((err) => {
                        loadingShow(false);
                        Message.error('Sync failed!!!');
                    });
            }
        }
        if (args.item.id === 'sync_all_from_pronto_api') {
            gridCPWorkorder.showSpinner();

            await SyncFullProntoWorkOrders()
                .then((result: AxiosResponse) => {
                    gridCPWorkorder?.showSpinner();
                    if (result.status == 200) {
                        Message.success('Synced successfully...');
                    }
                })
                .catch((err: any) => {
                    Message.error('Sync failed!!!');
                });
            gridCPWorkorder.hideSpinner();
        }
        if (args.item.id === 'sync_full') {
            if (isResetDataLoading || isDataResettingComponentHandle) {
                Message.error('Data is resetting...');
            } else {
                setResetData(true);
            }
        }
        if (args.item.id === 'fetchRecords_from_erp') {
            setQuestionDialog(true);
        }
        if (args.item.id === 'fetchRecords_from_pronto') {
            let result = await GetMaxProntoRowIdData();
            let maxProntoRowId;
            if (result.status === 200) {
                maxProntoRowId = result.data;
            }

            let theTableName = await GetTablenameFromTask('ORDERS');
            if (theTableName === '') {
                theTableName = 'job5mfj';
            } else {
                theTableName = theTableName.trim();
                let theValue = theTableName.split(' ');
                theTableName = theValue[theValue.length - 1];
            }
            // let theRowIds = gridCPWorkorder
            //   .getSelectedRecords()
            //   .map((x: any) => x.pronto_row_id)
            //   .toString();
            let theQuery = `Select *
                            from ${theTableName}
                            where job_type = 'J'
                              and row_id > (${maxProntoRowId});`;
            Message.info('Please wait for the response. It may take a while');
            let count: number = 11;
            let interval = setInterval(() => {
                count--;
                loadingShow(true, 'Checking... ' + count + ' seconds');
                if (count === 0) {
                    clearInterval(interval);
                    isAgentAlive = false;
                    Message.info('No response to procced. Please try again later.');
                    Message.error(
                        'Windows Agent is not currently available, please contact system administrator.'
                    );
                    loadingShow(false);
                }
                if (isAgentAlive) {
                    clearInterval(interval);
                    isAgentAlive = false;
                    loadingShow(false);
                }
            }, 1000);
            SendRequest(theQuery, 'SYNCED_NEW_RECORDS', undefined, true);
        }
        if (args.item.id === 'assign_order') {
            if (gridCPWorkorder?.getSelectedRecords().length > 0) {
                let theDatas = gridCPWorkorder?.getSelectedRecords() as any;
                setTheDatas(theDatas);
                setHideDialogEventPlan(true);
            } else {
                Message.error('Select a Work Order...');
            }
        }

        if (args.item.id === 'changes') {
            if (clickTimes === 0) {
                setGridGetQuery('mex-order');
                setCurrentQuery(`/changes`);
                setClickTimes(1);
            } else {
                setGridGetQuery('order');
                buildQuery('');
                setClickTimes(0);
            }
        }

        if (args.item.id === 'commit_mex') {
            setcommitToErpClicked(true);
        }

        if (args.item.id === 'apply_template') {
            if (gridCPWorkorder?.getSelectedRecords().length > 0) {
                dispatch(setIsWorkOrderDataChange(false));
                dispatch(setIsGlobalDialogClosed(false));
                let theDatas = gridCPWorkorder?.getSelectedRecords() as any;
                setOrderDetail(theDatas);
                setShowTemplateDialog(true);
            }
        }
        if (args.item.id === 'show_operations') {
            if (gridCPWorkorder?.getSelectedRecords().length > 0) {
                let theDatas = gridCPWorkorder?.getSelectedRecords();
                /*  if (theDatas.length > 50) {
                     Message.info("Maximum 50 records can be selected.")
                 } else { */
                let theCodes = theDatas
                    .map((theData: any) => {
                        return theData.order_code;
                    })
                    .toString();
                dispatch(setSearchCaseOp(theCodes));
                dispatch(setSearchCaseOrder(''));
                /*  } */
            }
        }
        if (args.item.id === 'show_resources') {
            if (gridCPWorkorder?.getSelectedRecords().length > 0) {
                let theDatas = gridCPWorkorder?.getSelectedRecords();
                let theCodes = theDatas
                    .map((theData: any) => {
                        return theData.order_code;
                    })
                    .toString();
                dispatch(setSearchCaseGantt(theCodes));
            }
        }
        if (args.item.id === 'mass_edit') {
            if (gridCPWorkorder?.getSelectedRecords().length > 0) {
                setMassiveEditDialog(true);
            }
        }
        if (args.item.id === 'apply_default_template') {
            if (gridCPWorkorder?.getSelectedRecords().length > 0) {
                let theDatas: any[] = [];
                let theData: any = gridCPWorkorder?.getSelectedRecords()[0] as any;
                theDatas.push(theData);

                if (
                    theDatas[0]?.pm_schedule_id === undefined ||
                    theDatas[0]?.pm_schedule_id === ''
                ) {
                    Message.info('There is no PM Schedule ID');
                    return;
                }
                preparingTemplatePoint(theDatas, theDatas[0].pm_schedule_id);
            }
        }
    };

    // const rowDataBound = (args: RowDataBoundEventArgs) => {
    //   const rowData = args.data as any;
    //   let rowBackgroundColor = 'transparent';

    //   if (!rowData.hasOperation) {
    //     rowBackgroundColor = '#b0a49e';
    //   }

    //   if (args.row) {
    //     args.row.setAttribute(
    //       'style',
    //       `background-color: ${rowBackgroundColor};`
    //     );
    //   }
    // };
    const queryCellInfo = (args: QueryCellInfoEventArgs) => {
        if (
            args.column &&
            args.column.type === 'checkbox' &&
            args.data &&
            args.cell
        ) {
            let theData = args.data as any;
            if (theData) {
                let isEffected = theData.isEffected;
                let theCurrenColor = 'tranparent';
                if (isEffected) {
                    theCurrenColor = '#8ECDDD';
                }
                args.cell.setAttribute('style', `background-color:${theCurrenColor};`);
            }
        }

        //     if (
        //         args.column &&
        //         args.column.field === 'priority_code' &&
        //         args.data &&
        //         args.cell
        //     ) {
        //       let theData = args.data as any;
        //       if (theData) {
        //         let priority_color = theData.priority_color;
        //         const color = priority_color;
        //         args.cell.setAttribute('style', `background-color:${color};`);      }
        //       }
    }


    const priorityColor = (args: any) => {
        let color = PriorityColorData.find(
            (x: any) => x.priority_code?.trim() === args.priority_code?.trim()
        )?.priority_color;
        return (
            <div
                style={{
                    backgroundColor: color,
                    borderRadius: 7,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <span>{args.priority_code}</span>
            </div>
        );
    };
    const statusCodeTemplate = (args: any) => {
        return (
            <div>
                {erpTypeName === ERP_TYPE ? <span>{args.status_code}</span> : <span>{args.status_id}</span>}
            </div>
        );
    };
    const typeTemplate = (args: any) => {
        return (
            <div>
                {erpTypeName === ERP_TYPE ? <span>{args.type_code}</span> : <span>{args.type_id}</span>}
            </div>
        );
    };

    const revisionTemplate = (args: any) => {
        if (args.revision_code === 0) {
            return <span></span>;
        }

        return <span>{args.revision_alias}</span>;
    };

    const materialColor = (args: any) => {
        return (
            <div
                style={{
                    backgroundColor: args.material_status,
                    borderRadius: 7,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '20px',
                }}
            >
                <span> </span>
            </div>
        );
    };
    const contextMenuClick = (args: any) => {
        if (args.item.id === 'view') {
            const data = gridCPWorkorder?.getSelectedRecords()[0] as any;
            if (data.order_code) {
                setCurrentWOC(data.order_code);
                setHideAddDialog(true);
            } else {
                Message.info('There is no order to transiction');
            }
        }
        if (args.item.id === 'materials') {
            const data = gridCPWorkorder?.getSelectedRecords()[0] as any;
            if (data.order_code) {
                g_worder = data.order_code;
            } else {
                Message.info('There is no order to transiction');
                return;
            }
            context.setTabChangeMaterials(true);
            context.setDataChangeMaterials(true);
        }
    };

    // const durationTemplate = (args: any) => {
    //   const startDate = new Date(args.scheduled_start_date);
    //   const endDate = new Date(args.scheduled_end_date);

    //   let difference = endDate.getTime() - startDate.getTime();

    //   let differenceAsDays = Math.round(difference / (1000 * 3600));
    //   return (
    //     <div>
    //       {differenceAsDays > 0 ? (
    //         <div>
    //           <span>{differenceAsDays}</span>
    //         </div>
    //       ) : (
    //         <></>
    //       )}
    //     </div>
    //   );
    // };
    const orderCodeTemplate = (args: any) => {
        const data = args;
        const orderCode = data.order_code;

        let tooltipText = '';
        if (data?.isCommitFailed && data.commitFailedMessage) {
            tooltipText = data.commitFailedMessage.replace(new RegExp('^' + orderCode), '').trim();
        }
        return (
            <span
                className={`order-code-cell ${data?.isCommitFailed ? 'error' : ''}`}
                title={tooltipText}
            >
                {orderCode}
            </span>
        );
    };

    const itemTemplateShiftColor = (data: any): JSX.Element => {
        return (
            <span>
                <span
                    id='exceptiontColor'
                    style={{ backgroundColor: data.rostercolor }}
                ></span>
                <span>{data.rosterCode + ' - ' + data.description}</span>
            </span>
        );
    };

    const isAttachmentsTemplate = (args: any) => {
        const data = undefined;
        return (
            <div>
                {data !== undefined ? (
                    <div>
                        <span>{args.order_code}</span>
                        <AiOutlinePaperClip color='#999999' size={17} />
                    </div>
                ) : (
                    <div>
                        <span
                            style={{
                                color:
                                    !args.has_operation && reduxSearchS.planId
                                        ? '#FFA500'
                                        : args.has_plan
                                            ? '#0380fc'
                                            : '#ffffff',
                                fontWeight: args.has_plan ? '900' : 'normal',
                            }}
                        >
                            {args.order_code}
                            {!args.has_operation && reduxSearchS.planId ? (
                                <GiDigDug color='#3b82f6' size={17} />
                            ) : (
                                ''
                            )}
                        </span>
                    </div>
                )}
            </div>
        );
    };
    const clearFilter = () => {
        setIsFilterActive(false);
        localStorage.setItem('isFilterActive', JSON.stringify(false));
        departmentFMSCom.value = [];
        sectionFMSCom.value = [];
        prontoReferenceFMSCom.value = [];
        holdReasonFMSCom.value = [];
        revisionCodeFMSCom.value = [];
        workorderCodeFMSCom.value = '';
        statusFMSCom.value = [];
        teamFMSCom.value = [];
        shiftFMSCom.value = [];
        tradeFMSCom.value = [];
        OPStatusFMSCom.value = [];
        referenceFMSCom.value = '';
        assetFMSCom.value = '';
        parentAssetFMSCom.value = '';
        typeFMSCom.value = [];
        hasProblem.value = [];
        respFMSCom.value = [];
        priorityFMSCom.value = [];
        ScheduleNumberFMSCom.value = '';
        if (startDateFMSCom) {
            startDateFMSCom.value = '';
        }
        if (plannedStartDateFMSCom) {
            plannedStartDateFMSCom.value = '';
        }
        schdeduleStartDateVal = '';
        plannedStartDateVal = '';
        ScheduleNumberFMSComValue = '';
        chips.selectedChips = [];
        priorityFMSComValue = [];
        statusFMSComValue = [];
        teamFMSComValue = [];
        shiftFMSComValue = [];
        tradeFMSComValue = [];
        OPStatusFMSComValue = [];
        departmentFMSComValue = [];

        hasProblemValue = [];
        typeFMSComValue = [];
        respFMSComValue = [];

        // referenceFMSComValue = '';
        setreferenceFMSComValue('');
        workorderCodeFMSComValue = '';

        if (current_query != '') {
            checkFilterParams = false;
            buildQuery('');
        }
    };
    const StatusMultiSelect = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        statusFMSCom = scope;
                    }}
                    field={{ value: 'value', text: 'alias' }}
                    id='ordersFilterMultiStatus'
                    url='global-filter?where=workorders$status$isEnabled€1'
                    placeHolder='WO Status'
                    value={statusFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectordersFilterMultiStatus',
                                '{"value":[]}'
                            );
                        }
                        statusFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };

    const TeamMultiSelect = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        teamFMSCom = scope;
                    }}
                    field={{ value: 'team_code', text: 'team_code' }}
                    id='ordersFilterMultiTeam'
                    url='team'
                    placeHolder='Select a Team'
                    value={teamFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectordersFilterMultiTeam',
                                '{"value":[]}'
                            );
                        }
                        teamFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };
    const ShiftMultiSelect = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        shiftFMSCom = scope;
                    }}
                    field={{ value: 'rosterCode', text: 'rosterCode' }}
                    id='ordersFilterMultiShift'
                    url='shift/Shift/'
                    placeHolder='Select a Shift'
                    value={shiftFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectordersFilterMultiShift',
                                '{"value":[]}'
                            );
                        }
                        shiftFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };

    const TradeMultiSelect = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        tradeFMSCom = scope;
                    }}
                    field={{ value: 'trade_code', text: 'label' }}
                    id='ordersFilterMultiTrade'
                    url='trade'
                    placeHolder='Select a Trade'
                    value={tradeFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectordersFilterMultiTrade',
                                '{"value":[]}'
                            );
                        }
                        tradeFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };

    const OPStatusMultiSelect = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        OPStatusFMSCom = scope;
                    }}
                    field={{ value: 'value', text: 'alias' }}
                    id='ordersFilterMultiOPStatus'
                    url='global-filter?where=operation$status$isEnabled€1'
                    placeHolder='OP Status'
                    value={OPStatusFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectordersFilterMultiOPStatus',
                                '{"value":[]}'
                            );
                        }
                        OPStatusFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };


    const PriorityMultiSelect = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        priorityFMSCom = scope;
                    }}
                    field={{ value: 'value', text: 'alias' }}
                    id='ordersFilterMultiPriority'
                    url='global-filter?where=workorders$priority$isEnabled€1'
                    placeHolder='Select a Priority'
                    value={priorityFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectordersFilterMultiPriority',
                                '{"value":[]}'
                            );
                        }
                        priorityFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };
    const WorkOrderCodeInput = () => {
        return (
            <div>
                <TextBoxComponent
                    type={'text'}
                    ref={(scope: TextBoxComponent) => {
                        workorderCodeFMSCom = scope;
                    }}
                    autocomplete='off'
                    enablePersistence={true}
                    showClearButton
                    id='WorkOrderTextBox'
                    placeholder='Work Order'
                    value={workorderCodeFMSComValue}
                    onChange={(args: any) => {
                        if (args.target.value == '') {
                            localStorage.setItem('textboxWorkOrderTextBox', '{"value":""}');
                        }

                        workorderCodeFMSComValue = args.target.value;
                    }}


                />
            </div>
        );
    };
    const ScheduleNumberComponent = () => {
        return (
            <div>
                {ERP_TYPE === erpTypeName && (
                    <TextBoxComponent
                        type={'text'}
                        ref={(scope: TextBoxComponent) => {
                            ScheduleNumberFMSCom = scope;
                        }}
                        autocomplete='off'
                        id='PMSchedulerNumberTextComponent'
                        showClearButton
                        placeholder='PM Schedule Number'
                        value={ScheduleNumberFMSComValue}
                        enablePersistence={true}
                        onChange={(args: any) => {
                            ScheduleNumberFMSComValue = args.target.value;
                        }}
                    />
                )}
            </div>
        );
    };
    const DepartmentFilterInput = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        departmentFMSCom = scope;
                    }}
                    field={{ value: 'value', text: 'alias' }}
                    id='DepartmentordersFilterMultiPriority'
                    url='global-filter?where=workorders$department$isEnabled€1&='
                    placeHolder={
                        ERP_TYPE == 'MEX' ? 'Select a Department' : 'Select a Branch'
                    }
                    value={departmentFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectDepartmentordersFilterMultiPriority',
                                '{"value":[]}'
                            );
                        }
                        departmentFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };
    const SectionFilterInput = () => {
        return (
            <div>
                {ERP_TYPE !== erpTypeName && (
                    <GlobalMultiSelection
                        refDD={(scope: MultiSelectC) => {
                            sectionFMSCom = scope;
                        }}
                        field={{ value: 'value', text: 'alias' }}
                        id='SectionordersFilterMulti'
                        url='global-filter?where=workorders$section$isEnabled€1&='
                        placeHolder='Select a Section'
                        value={sectionFMSComValue}
                        onChange={(e: any) => {
                            if (e.value.length == 0) {
                                localStorage.setItem(
                                    'multiselectSectionordersFilterMulti',
                                    '{"value":[]}'
                                );
                            }
                            sectionFMSComValue = e.value;
                        }}
                        enablePersistence={true}
                    />
                )}
            </div>
        );
    };
    const PontoReferenceFilterInput = () => {
        return (
            <div>
                {ERP_TYPE !== erpTypeName && (
                    <GlobalMultiSelection
                        refDD={(scope: MultiSelectC) => {
                            prontoReferenceFMSCom = scope;
                        }}
                        field={{ value: 'value', text: 'alias' }}
                        id='ProntoReferenceOrdersFilterMulti'
                        url='global-filter?where=workorders$reference$isEnabled€1&='
                        placeHolder='Select a Reference'
                        value={prontoReferenceFMSComValue}
                        onChange={(e: any) => {
                            if (e.value.length == 0) {
                                localStorage.setItem(
                                    'multiselectProntoReferenceOrdersFilterMulti',
                                    '{"value":[]}'
                                );
                            }
                            prontoReferenceFMSComValue = e.value;
                        }}
                        enablePersistence={true}
                    />
                )}
            </div>
        );
    };
    const HoldReasonFilterInput = () => {
        return (
            <div>
                {ERP_TYPE !== erpTypeName && (
                    <GlobalMultiSelection
                        refDD={(scope: MultiSelectC) => {
                            holdReasonFMSCom = scope;
                        }}
                        field={{ value: 'value', text: 'alias' }}
                        id='reasonOrdersFilterMulti'
                        url='global-filter?where=workorders$reason$isEnabled€1&='
                        placeHolder='Select a Hold Reason'
                        value={holdReasonFMSComValue}
                        onChange={(e: any) => {
                            if (e.value.length == 0) {
                                localStorage.setItem(
                                    'multiselectreasonOrdersFilterMulti',
                                    '{"value":[]}'
                                );
                            }
                            holdReasonFMSComValue = e.value;
                        }}
                        enablePersistence={true}
                    />
                )}
            </div>
        );
    };
    const RevisionCodeFilterInput = () => {
        return (
            <div>
                {ERP_TYPE !== erpTypeName && (
                    <GlobalMultiSelection
                        refDD={(scope: MultiSelectC) => {
                            revisionCodeFMSCom = scope;
                        }}
                        field={{ value: 'value', text: 'alias' }}
                        id='revisionOrdersFilterMulti'
                        url='global-filter?where=workorders$revision$isEnabled€1&='
                        placeHolder='Select a Revision'
                        value={revisionCodeFMSComValue}
                        onChange={(e: any) => {
                            if (e.value.length == 0) {
                                localStorage.setItem(
                                    'multiselectrevisionOrdersFilterMulti',
                                    '{"value":[]}'
                                );
                            }
                            revisionCodeFMSComValue = e.value;
                        }}
                        enablePersistence={true}
                    />
                )}
            </div>
        );
    };
    const ReferenceInput = () => {
        return (
            <div>
                {ERP_TYPE === erpTypeName && (
                    <TextBoxComponent
                        enablePersistence={true}
                        type={'text'}
                        ref={(scope: TextBoxComponent) => {
                            referenceFMSCom = scope;
                        }}
                        autocomplete='off'
                        showClearButton
                        placeholder='Reference'
                        id='ReferenceTextBox'
                        value={referenceFMSComValue}
                        onChange={(args: any) => {
                            // referenceFMSComValue = args.target.value;
                            setreferenceFMSComValue(args.target.value);
                        }}
                    />
                )}
            </div>
        );
    };
    const AssetInput = () => {
        return (
            <div>
                <TextBoxComponent
                    type={'text'}
                    ref={(scope: TextBoxComponent) => {
                        assetFMSCom = scope;
                    }}
                    autocomplete='off'
                    showClearButton
                    placeholder='Asset'
                    id='AssetTextBox'
                    enablePersistence={true}
                    value={assetFMSComValue}
                    onChange={(args: any) => {
                        if (args.target.value == '') {
                            localStorage.setItem('textboxAssetTextBox', '{"value":""}');
                        }

                        assetFMSComValue = args.target.value;
                    }}
                />
            </div>
        );
    };
    const AssetParentCodeInput = () => {
        return (
            <div>
                <TextBoxComponent
                    type={'text'}
                    ref={(scope: TextBoxComponent) => {
                        parentAssetFMSCom = scope;
                    }}
                    autocomplete='off'
                    showClearButton
                    placeholder='Parent WO'
                    id='ParentWoTextBox'
                    enablePersistence={true}
                    value={parentAssetFMSComValue}
                    onChange={(args: any) => {
                        if (args.target.value == '') {
                            localStorage.setItem('textboxParentAssetTextBox', '{"value":""}');
                        }
                        parentAssetFMSComValue = args.target.value;
                    }}
                />
            </div>
        );
    };

    const TypeInput = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        typeFMSCom = scope;
                    }}
                    //field={{ value: 'sys_tbl_code', text: 'sys_description' }}
                    field={
                        erpTypeName === ERP_TYPE
                            ? { value: 'value', text: 'description' }
                            : { value: 'value', text: 'alias' }
                    }
                    id='operationFilterMultiType'
                    //url='system-config?where=P3'
                    url={'global-filter?where=workorders$type$isEnabled€1'}
                    placeHolder='Select a Type'
                    value={typeFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectoperationFilterMultiType',
                                '{"value":[]}'
                            );
                        }

                        typeFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };
    const hasProblemComponent = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        hasProblem = scope;
                    }}
                    field={{ value: 'value', text: 'alias' }}
                    id='hasProblemFilterMulti'
                    url={'global-filter?where=workorders$problem$isEnabled€1'}
                    placeHolder='Data Integrity'
                    value={hasProblemValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselecthasProblemFilterMulti',
                                '{"value":[]}'
                            );
                        }

                        hasProblemValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };
    //global-filter?where=workorders$type$isEnabled€1
    const RespInput = () => {
        return (
            <>
                {ERP_TYPE !== erpTypeName && (
                    <GlobalMultiSelection
                        refDD={(scope) => {
                            respFMSCom = scope;
                        }}
                        field={{ value: 'value', text: 'alias' }}
                        id='ordersFilterMultiResp'
                        //url='system-config?where=P2'
                        url='global-filter?where=workorders$responsibility$isEnabled€1'
                        placeHolder='Select a Resp'
                        onChange={(e) => {
                            if (e.value.length == 0) {
                                localStorage.setItem(
                                    'multiselectordersFilterMultiResp',
                                    '{"value":[]}'
                                );
                            }
                            respFMSComValue = e.value;
                        }}
                        value={respFMSComValue}
                        enablePersistence={true}
                    />
                )}
            </>
        );
    };

    const ScheduleStartDateInput = () => {
        return (
            <div>
                <DateRangePickerComponent
                    placeholder='Schedule Start Date'
                    id='ScheduleStartDateFilter'
                    ref={(a) => {
                        startDateFMSCom = a;
                    }}
                    enablePersistence={true}
                    enabled={true}
                    format={'dd/MM/yyyy'}
                    showClearButton={true}
                    value={schdeduleStartDateVal}
                    onChange={(e: any) => {
                        if (e.value == null) {
                            localStorage.setItem(
                                'daterangepickerScheduleStartDateFilter',
                                '{"startDate":null,"endDate":null,"value":""}'
                            );
                        }

                        schdeduleStartDateVal = e.value;
                    }}
                ></DateRangePickerComponent>
            </div>
        );
    };

    const PlannedStartDateInput = () => {
        return (
            <div>
                <DateRangePickerComponent
                    placeholder='Planned Start Date'
                    id='PlannedStartDateFilter'
                    ref={(a) => {
                        plannedStartDateFMSCom = a;
                    }}
                    enablePersistence={true}
                    enabled={true}
                    format={'dd/MM/yyyy'}
                    showClearButton={true}
                    value={plannedStartDateVal}
                    onChange={(e: any) => {
                        if (e.value == null) {
                            localStorage.setItem(
                                'daterangepickerPlannedStartDateFilter',
                                '{"startDate":null,"endDate":null,"value":""}'
                            );
                        }

                        plannedStartDateVal = e.value;
                    }}
                ></DateRangePickerComponent>
            </div>
        );
    };

    const FilterPrio = () => {
        buildQuery('');
    };
    const theColumns = [
        {
            field: 'app',
            textAlign: 'Left',
            headerText: 'App',
            width: 80,
            visible: false,
        },
        {
            field: 'order_id',
            textAlign: 'Left',
            headerText: 'Workorder ID',
            width: 80,
            visible: false,
            isPrimaryKey: true,
        },
        {
            field: 'order_code_id',
            textAlign: 'Left',
            headerText: 'Workorder code ID',
            width: 80,
            visible: false,
        },
        {
            field: 'isEffected',
            textAlign: 'Left',
            width: 50,
            visible: false,
            clipMode: 'EllipsisWithTooltip',
            type: 'boolean',
        },

        {
            field: 'priority_code',
            template: priorityColor.bind(this),
            headerText: 'Priority Code',
            width: 60,
            clipMode: 'EllipsisWithTooltip',
            edit: getParamsDD(
                { value: 'value', text: 'alias' },
                'priority_code',
                'global-filter?where=workorders$priority$isEnabled€1',
                true
            ),
        },
        {
            field: 'asset_code_parent',
            headerText: 'Parent Asset',
            visible: false,
            width: 140,
            clipMode: 'EllipsisWithTooltip',
        },
        // {
        //   field: 'material_status',
        //  // template: materialColor.bind(this),
        //   headerText: 'Material Status',
        //   width: 40,
        //   visible: ERP_TYPE === erpTypeName ? false : true,
        //   clipMode: 'EllipsisWithTooltip',
        // },

        {
            field: 'asset_code',
            headerText: 'Asset Code',
            width: 150,
            clipMode: 'EllipsisWithTooltip',
        },
        {
            field: 'asset_description',
            headerText: 'Asset Description',
            clipMode: 'EllipsisWithTooltip',
            visible: ERP_TYPE === erpTypeName ? false : false,
            allowEditing: true,
        },
        {
            field: 'order_code',
            textAlign: 'Left',
            //template: isAttachmentsTemplate.bind(this),
            template: orderCodeTemplate.bind(this),
            headerText: 'Workorder Code',
            width: 100,
            isPrimaryKey: true,
            clipMode: 'EllipsisWithTooltip',
        },

        {
            field: 'description',
            headerText: 'Description',
            clipMode: 'EllipsisWithTooltip',
            allowEditing: true,
        },
        {
            field: 'scheduled_start_date',
            headerText: 'Scheduled Start Date',
            width: 200,
            clipMode: 'EllipsisWithTooltip',
            type: 'datetime',
            format: 'dd/MM/yyyy HH:mm',
            allowEditing: false,
        },
        {
            field: 'scheduled_end_date',
            headerText: 'Scheduled End Date',
            width: 200,
            clipMode: 'EllipsisWithTooltip',
            type: 'datetime',
            format: 'dd/MM/yyyy HH:mm',
            editType: 'datetimepickeredit',
            // edit: endDateParams,
            allowEditing: false,
        },
        {
            field: 'duration',
            // template: durationTemplate.bind(this),
            headerText: 'Duration',
            width: 150,
            type: 'number',
            format: '0.00',
        },
         {
            field: 'department_code',
            headerText: 'Department',
            visible: ERP_TYPE === erpTypeName ? true : false,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: true,
        },
        {
            field: 'status_code',
            headerText: 'Status Code',
            width: 150,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: true,
            template: statusCodeTemplate.bind(this),
            edit: getParamsDD(
                erpTypeName === ERP_TYPE
                    ? { value: 'alias', text: 'alias' }
                    : { value: 'alias', text: 'alias' },
                'status_code',
                'global-filter?where=workorders$status$isEnabled€1',
                true
            ),
        },
        {
            field: 'type_code',
            headerText: 'Type Code',
            width: 120,
            clipMode: 'EllipsisWithTooltip',
            template: typeTemplate.bind(this),
            allowEditing: true,

            edit: getParamsDD(
                erpTypeName === ERP_TYPE
                    ? { value: 'description', text: 'alias' }
                    : { value: 'alias', text: 'alias' },
                'type_code',
                'global-filter?where=workorders$type$isEnabled€1',
                true
            ),
            // edit: getParamsDD(
            //   { value: 'sys_tbl_code', text: 'sys_description' },
            //   'type_code',
            //   'system-config?where=P3',
            //   true
            // ),
        },
        ERP_TYPE == 'MEX'
            ? {
                field: 'pm_schedule_number',
                headerText: 'PM Schedule Number',
                width: 100,
                clipMode: 'EllipsisWithTooltip',
                visible: ERP_TYPE === erpTypeName ? true : false,
            }
            : {
                field: 'pm_schedule_id',
                headerText: 'PM Schedule ID',
                width: 200,
                clipMode: 'EllipsisWithTooltip',
                visible: ERP_TYPE === erpTypeName ? true : false,
            },

        ,
        {
            field: 'team_code',
            headerText: 'Team',
            width: 110,
            visible: ERP_TYPE === erpTypeName ? true : true,
            clipMode: 'EllipsisWithTooltip',
            edit: getParamsDD(
                { text: 'team_code', value: 'team_code' },
                'team_code',
                'team',
                true
            ),
        },
        {
            field: 'shift',
            headerText: 'Shift',
            width: 110,
            visible: ERP_TYPE === erpTypeName ? true : true,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: true,
            edit: getParamsDD(
                { text: 'rosterCode', value: 'rosterId' },
                'shift',
                'shift'
            ),
        },
        {
            field: 'site_details_1',
            headerText: 'Reference',
            width: 120,
            clipMode: 'EllipsisWithTooltip',
            visible: true,
            allowEditing: false,
            edit:
                ERP_TYPE !== erpTypeName &&
                getParamsDD(
                    { value: 'description', text: 'alias' },
                    'status_code',
                    'global-filter?where=workorders$reference$isEnabled€1',
                    true
                ),
        },
        {
            field: 'order_resp_code',
            headerText: 'Responsibility',
            width: 150,
            visible: ERP_TYPE === erpTypeName ? false : true,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: true,
            edit: getParamsDD(
                { value: 'sys_tbl_code', text: 'sys_description' },
                'order_resp_code',
                'system-config?where=P2',
                true
            ),
        },
        {
            field: 'reason',
            headerText: 'Hold Reason',
            width: 120,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: true,
            visible: ERP_TYPE !== 'MEX' ? true : false,
            edit: getParamsDD(
                { value: 'value', text: 'value' },
                'reason',
                'global-filter?where=workorders$reason$isEnabled€1',
                true
            ),
        },
        {
            field: 'planned_start_date',
            headerText: 'Planned Start Time',
            width: 200,
            clipMode: 'EllipsisWithTooltip',
            type: 'datetime',
            format: 'dd/MM/yyyy HH:mm',
            allowEditing: false,
            edit: { params: { format: 'dd/MM/yyyy HH:mm' } },
        },
        {
            field: 'planned_end_date',
            headerText: 'Planned End Time',
            width: 200,
            clipMode: 'EllipsisWithTooltip',
            type: 'datetime',
            format: 'dd/MM/yyyy HH:mm',
            allowEditing: false,
            edit: { params: { format: 'dd/MM/yyyy HH:mm' } },
        },
        {
            field: 'wo_labour_cost',
            headerText: 'Labour Cost',
            width: 150,
            clipMode: 'EllipsisWithTooltip',
            visible: ERP_TYPE === erpTypeName ? true : false,
            allowEditing: true,
            format: 'C2',
        },
        {
            field: 'wo_material_cost',
            headerText: 'Material Cost',
            width: 150,
            clipMode: 'EllipsisWithTooltip',
            visible: ERP_TYPE === erpTypeName ? true : false,
            allowEditing: true,
            format: 'C2',
        },
        {
            field: 'wo_other_cost',
            headerText: 'Other Cost',
            width: 150,
            clipMode: 'EllipsisWithTooltip',
            visible: ERP_TYPE === erpTypeName ? true : false,
            allowEditing: true,
            format: 'C2',
        },
        {
            field: 'revision_code',
            headerText: 'Revision',
            width: 150,
            visible: ERP_TYPE === erpTypeName ? false : true,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: false,
            template: revisionTemplate.bind(this)
        },
        {
            field: 'asset_code_parent',
            headerText: 'Parent WO',
            width: 150,
            visible: ERP_TYPE === erpTypeName ? false : true,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: false,
        },
        {
            field: 'pm_schedule_id',
            headerText: 'PM Schedule ID',
            width: 150,
            clipMode: 'EllipsisWithTooltip',
            visible: ERP_TYPE === erpTypeName ? false : true,
        },
        {
            field: 'duration',
            // template: durationTemplate.bind(this),
            headerText: 'Planned Duration',
            width: 150,
            visible: false,
            format: '0.00',
        },

        {
            field: 'actual_start_date',
            headerText: 'Actual Start Date',
            width: 200,
            clipMode: 'EllipsisWithTooltip',
            type: 'datetime',
            format: 'dd/MM/yyyy HH:mm',
            allowEditing: false,
            edit: { params: { format: 'dd/MM/yyyy HH:mm' } },
            visible: false,
        },
        {
            field: 'actual_end_date',
            headerText: 'Actual End Time',
            width: 200,
            clipMode: 'EllipsisWithTooltip',
            type: 'datetime',
            format: 'dd/MM/yyyy HH:mm',
            allowEditing: false,
            edit: { params: { format: 'dd/MM/yyyy HH:mm' } },
            visible: false,
        },

        {
            field: 'creation_date',
            headerText: 'Created Date',
            width: 140,
            clipMode: 'EllipsisWithTooltip',
            type: 'datetime',
            format: 'dd/MM/yyyy HH:mm',
            visible: false,
            allowEditing: false,
        },
        {
            field: 'custom_txt_field6',
            headerText: 'Created By',
            width: 140,
            clipMode: 'EllipsisWithTooltip',
            visible: false,
            allowEditing: false,
        },

        {
            field: 'order_branch',
            headerText: 'Account Code',
            width: 140,
            clipMode: 'EllipsisWithTooltip',
            visible: false,
            allowEditing: false,
        },
        {
            field: 'mex_order_instruction',
            headerText: 'Instructions',
            visible: false,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: true,
        },
        {
            field: 'mex_order_safety_note',
            headerText: 'Safety Notes',
            visible: false,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: true,
        },

        {
            field: 'order_section_code',
            headerText: 'Section',
            width: 120,
            visible: ERP_TYPE === erpTypeName ? false : true,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: true,
            edit: getParamsDD(
                { value: 'sys_tbl_code', text: 'sys_description' },
                'order_section_code',
                'system-config?where=N4',
                true
            ),
        },
        {
            field: 'order_branch',
            headerText: 'Branch',
            width: 40,
            visible: ERP_TYPE === erpTypeName ? false : true,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: false,
        },
        {
            field: 'order_branch_id',
            headerText: 'Branch ID',
            width: 40,
            visible: false,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: false,
            ERP_TYPE,
        },
        {
            field: 'site_details_2',
            headerText: 'Site Details 2',
            width: 40,
            clipMode: 'EllipsisWithTooltip',
            visible: false,
            allowEditing: true,
        },
        {
            field: 'site_details_3',
            headerText: 'Site Details 3',
            width: 40,
            clipMode: 'EllipsisWithTooltip',
            visible: false,
            allowEditing: true,
        },
        {
            field: 'entered_by',
            headerText: 'Entered By',
            width: 40,
            visible: ERP_TYPE === erpTypeName ? false : true,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: true,
        },
        {
            field: 'approval_date',
            headerText: 'Approval Date',
            width: 150,
            clipMode: 'EllipsisWithTooltip',
            type: 'datetime',
            format: 'dd/MM/yyyy HH:mm',
            edit: { params: { format: 'dd/MM/yyyy HH:mm' } },
            visible: false,
            allowEditing: true,
        },
    ];
    const onCreated = (grid: GridComponent) => {
        gridCPWorkorder = grid;
        if (gridCPWorkorder) {
            gridCPWorkorder.allowReordering = reduxSearchS.reOrderAble;
        }
        if (gridRef) {
            gridRef(grid);
        }
    };
    useEffect(() => {
        const isFilterActiveLS = localStorage.getItem('isFilterActive');
        if (isFilterActiveLS !== null) {
            setIsFilterActive(JSON.parse(isFilterActiveLS));
        }
    }, []);
    useEffect(() => {
        if (context.isClickedQuickLoad) {
            let datas = gridCPWorkorder.getSelectedRecords();
            if (datas.length > 0) {
                const serverOffsetMillis = 60 * 1000 * gmt * (-60);

                const localOffset = new Date().getTimezoneOffset();
                const localOffsetMillis = 60 * 1000 * localOffset;

                const differenceOffsetMillis = serverOffsetMillis - localOffsetMillis;
                let timezoneOffset= gmt * -60;

                const editOrders = async () => {
                    datas.map((item: any) => {
                        let date = context.quickScheduleDateOnLoad;
                        const timePart = moment(item.scheduled_start_date).format('HH:mm:ss');
                        if (typeof date === 'string' && !(date as string).includes(':')) {
                            let dateNew = moment(`${date}T${timePart}`);
                            item.scheduled_start_date = moment(dateNew).toDate();
                            if(item.scheduled_start_date){
                                item.scheduled_start_date = new Date(
                                    new Date(item.scheduled_start_date)?.getTime() + differenceOffsetMillis
                                ).toString();
                            }
                            delete item.scheduled_end_date;
                        }
                    })
                    await EditWorkOrder(datas,timezoneOffset);
                    refreshGridFunction();
                };
                editOrders();
            }
        }
    }, [context.isClickedQuickLoad]);

    useEffect(() => {
        let mounted = true;
        const get = async () => {
            let theData = await getPriority();
            if (mounted) {
                setPriorityColorData(theData);
            }
        };
        get();
        setLoadSignal(true);
        if (needDidMount) {
            buildQuery('');
        }

        socket.on('OnDeletedOrdersFeedback', (data: any) => {
            let theData = JSON.parse(data);
            let theMessage = theData.request_sql;
            if (theMessage.includes('failed')) {
                Message.error(theMessage);
            } else {
                Message.success(theMessage);
            }
        });

        socket.on('OnSyncQueryFeedback', (data: any) => {
            isAgentAlive = true;
            let theData = JSON.parse(data);
            let theMessage = theData.request_sql;
            if (theMessage.includes('failed')) {
                Message.error(theMessage);
            } else {
                refreshGridFunction();
                Message.success(theMessage);
            }
        });
        socket.on('OnGetNewRecordQueryFeedback', (data: any) => {
            isAgentAlive = true;
            let theData = JSON.parse(data);
            let theMessage = theData.request_sql;
            if (theMessage.includes('failed')) {
                Message.error(theMessage);
            } else {
                refreshGridFunction();
                Message.success(theMessage);
            }
        });
        socket.on('onSyncOperationQueryFeedback', (data: any) => {
            isAgentAlive = true;
            let theData = JSON.parse(data);
            let theMessage = theData.request_sql;
            if (theMessage.includes('failed')) {
                Message.error(theMessage);
            } else {
                Message.success(theMessage);
            }
        });
        socket.on('OnResetOperationQueryFeedback', (data: any) => {
            isAgentAlive = true;
            let theData = JSON.parse(data);
            let theMessage = theData.request_sql;
            if (theMessage.includes('failed')) {
                Message.error(theMessage);
            } else {
                Message.success(theMessage);
            }
        });
        socket.on('OnResetDataQueryFeedback', (data: any) => {
            isAgentAlive = true;
            let theData = JSON.parse(data);
            let theMessage = theData.request_sql;
            if (theMessage.includes('failed')) {
                Message.error(theMessage);
            } else {
                refreshGridFunction();
                Message.success(theMessage);
            }
        });
        socket.connect();
        return () => {
            mounted = false
            socket.disconnect();
        };
    }, []);
    useEffect(() => {
        if (isWorkOrderDataChange) {
            buildQuery('');
        }
    }, [isGlobalDialogClosed, isWorkOrderDataChange]);

    useEffect(() => {
        if (reduxSearchS.isOrderPlanSelected) {
            const get = async () => {
                buildQuery('');
                dispatch(setIsAppliedEventPlan({ isAppliedEventPlan: false }));
            };
            if (isAppliedEventPlan) {
                get();
            }
        }
    }, [isAppliedEventPlan]);

    useEffect(() => {
        $('#work_orders').val(searchText);
        PriorityColorData?.map((elCol: any) => {
            $(`.e-chip-text${elCol.priority_code?.trim()}`).css(
                'background-color',
                `${elCol?.priority_color}`
            );
            var el = document.getElementsByClassName(
                `e-chip-text${elCol.priority_code?.trim()}`
            )[0] as any;
            if (el) {
                el.style.backgroundColor = elCol?.priority_color;
            }
        });
    }, [PriorityColorData]);
    useEffect(() => {
        if (
            (reduxSearchS.theOrSearchFromRedux &&
                reduxSearchS.theOrSearchFromRedux !== '') || searchText !== ''
        ) {
            $('#order-request').val(reduxSearchS.theOrSearchFromRedux);
            searchText = reduxSearchS.theOrSearchFromRedux;
            buildQuery('');
        }
    }, [reduxSearchS.theOrSearchFromRedux]);

    useEffect(() => {
        if (searchText !== '') {
            buildQuery('');
        }
    }, [searchText]);
    const massCallBack = async (args: any) => {
        if (gridCPWorkorder) {
            if (gridCPWorkorder?.getSelectedRecords().length > 0) {
                let flag: boolean = false;
                let theDatas = gridCPWorkorder?.getSelectedRecords();
                let theEdittedOp = [];
                loadingShow(true, 'Processing...');
                loadingShow(true, 'Just a second while getting operations....');
                let idList: string[] = [];
                theDatas.map((theData: any) => {
                    idList.push(theData.order_code?.toString());
                });
                loadingShow(true, 'Orders adjusting....');
                let theCodes = theDatas.map((theData: any) => {
                    if (args.dataOrder.scheduled_start_date) {
                        let theDifference = moment(
                            args.dataOrder.scheduled_start_date
                        ).diff(theData.scheduled_start_date, 'millisecond');
                        theData.scheduled_end_date = moment(
                            theData.scheduled_end_date?.toString()
                        )
                            .add(theDifference, 'millisecond')
                            .toDate();

                        args.dataOrder.scheduled_start_date =
                            args.dataOrder?.scheduled_start_date?.toString();

                        theData.scheduled_start_date =
                            args.dataOrder?.scheduled_start_date?.toString();
                    }
                    else {
                        flag = true;
                    }
                    return { ...theData, ...args.dataOrder };
                });
                try {
                } catch (error) {
                    Message.error('Error occured while updating operations');
                }

                // const differenceOffsetMillis = localOffsetMillis - serverOffsetMillis;
                //
                // theDatas.map((item: any) => {
                //     item.scheduled_start_date = new Date(
                //         new Date(item.scheduled_start_date).getTime() + differenceOffsetMillis
                //     ).toISOString();
                //     item.scheduled_end_date = new Date(
                //         new Date(item.scheduled_end_date).getTime() + differenceOffsetMillis
                //     ).toISOString();
                // });

                if (flag) {
                    theCodes.map((item: any) => {
                        delete item.scheduled_start_date;
                        delete item.scheduled_end_date;
                    })
                }
                EditMassOrder(
                    theCodes,
                    () => {
                        loadingShow(false);
                        Message.success('Success');
                        //buildQuery(refreshTokens[Math.floor(Math.random() * (3 + 1))]);
                        buildQuery('');
                        refreshGridFunction();
                    },
                    0
                );
            }
        }
    };
    const toolbarOptions: any = [
        { template: template.bind(this), align: 'Left' },
        'Add',
        // 'Delete',
        'Update',
        'Cancel',
        { template: assignShiftButton.bind(this) },
        { template: assignTeamButton.bind(this) },
        {
            text: 'Schedule',
            tooltipText: 'Scheduler',
            prefixIcon: 'e-timeline-month',
            id: 'scheduler',
        },
        {
            text: 'Refresh',
            tooltipText: 'Refresh',
            prefixIcon: 'e-repeat',
            id: 'refresh',
        },
        {
            text: 'Changes',
            tooltipText: 'Changes',
            id: 'changes',
        },
        {
            text: 'Commit to ERP',
            tooltipText: '',
            id: 'update_pronto_api',
            visible: ERP_TYPE === erpTypeName ? false : true,
        },
        {
            text: 'Commit To Erp',
            tooltipText: '',
            id: 'commit_mex',
            visible: ERP_TYPE === erpTypeName ? true : false,
        },
        {
            text: 'Apply Template',
            tooltipText: '',
            id: 'apply_template',
        },
        {
            text: 'Apply Default Template',
            tooltipText: '',
            id: 'apply_default_template',
        },
        {
            text: 'Show Operations',
            tooltipText: '',
            id: 'show_operations',
        },
        // {
        //   text: 'Show Resources',
        //   tooltipText: '',
        //   id: 'show_resources',
        // },
        {
            text: 'Edit',
            tooltipText: '',
            id: 'mass_edit',
        },
        {
            text: 'Sync From ERP',
            tooltipText: '',
            id: 'sync_from_erp',
            visible: ERP_TYPE === erpTypeName ? true : true,
        },
        {
            text: 'Reset Data',
            tooltipText: '',
            id: 'reset_pronto_data',
            visible: ERP_TYPE === erpTypeName ? false : true,
        },
        {
            text: 'Get New Data',
            tooltipText: '',
            id: 'fetchRecords_from_pronto',
            visible: ERP_TYPE === erpTypeName ? false : true,
        },
        {
            text: 'Assign WO',
            tooltipText: '',
            id: 'assign_order',
            visible: true,
        },
        { template: priorityColorChip.bind(this), align: 'Right' },
        'ColumnChooser',
        { text: 'Excel Export', id: 'ExcelExport' },
    ];
    return (
        <div>
            {/* {reduxSearchS.isResetDataLoading ? (
        <>{gridCPWorkorder.showSpinner()}</>
      ) : null} */}
            {!noNeedFilterPanel ? (
                <GlobalSearch
                    id={'cloud-planner-orders-filter'}
                    height={ERP_TYPE == 'MEX' ? '720px' : '915px'}
                    applyFilter={FilterPrio.bind(this)}
                    clearFilter={clearFilter.bind(this)}
                    isFilterActive={isFilterActive}
                    Component1={PriorityMultiSelect.bind(this)}
                    Component2={StatusMultiSelect.bind(this)}
                    Component3={AssetInput.bind(this)}
                    Component4={TypeInput.bind(this)}
                    Component5={RespInput.bind(this)}
                    Component6={ScheduleStartDateInput.bind(this)}
                    Component7={ReferenceInput.bind(this)}
                    Component8={WorkOrderCodeInput.bind(this)}
                    Component9={DepartmentFilterInput.bind(this)}
                    Component10={SectionFilterInput.bind(this)}
                    Component11={PontoReferenceFilterInput.bind(this)}
                    Component12={HoldReasonFilterInput.bind(this)}
                    Component13={ScheduleNumberComponent.bind(this)}
                    Component14={hasProblemComponent.bind(this)}
                    Component15={RevisionCodeFilterInput.bind(this)}
                    Component16={AssetParentCodeInput.bind(this)}
                    Component17={TeamMultiSelect.bind(this)}
                    Component18={ShiftMultiSelect.bind(this)}
                    Component19={TradeMultiSelect.bind(this)}
                    Component20={PlannedStartDateInput.bind(this)}
                    //Component21={OPStatusMultiSelect.bind(this)}
                />
            ) : null}
            <GlobalGrid
                id='cloud-planner-workorders'
                columns={theColumns}
                //height={'calc(-290px + 100vh)'}
                height={
                    !needExpandStatus ? 'calc(-310px + 100vh)' :
                        context.expandStatus
                            ? 'calc(40vh - 2px)'
                            : 'calc(-415px + 100vh)'
                }
                query={current_query}
                toolbarOptions={toolbarOptions}
                //get_query={'order'}
                get_query={gridGetQuery}
                edit_query={'order/edit'}
                delete_query={'order/delete'}
                signalOfLoad={loadSignal}
                refreshRequest={refreshRequest}
                contextMenuItems={contextMenuItems}
                contextMenuClick={contextMenuClick}
                gridRef={onCreated.bind(this)}
                allowMultiSelection={multiSelection}
                allowCheckBox
                excelQueryCellInfo={excelQueryCellInfo}
                additinalToolbarClick={toolbarClickExtends.bind(this)}
                queryCellInfo={queryCellInfo.bind(this)}
                additionalCrudParams={{ isEffected: 1 }}
                theEditOptions={editOptions}
                refreshRequestHandle={() => {
                    setrefreshRequest('false');
                }}
            />
            {showTemplateDialog ? (
                <GlobalDialog
                    // refDialog={(ref: DialogComponent) => (dialog = ref)}
                    showDialog={showTemplateDialog}
                    setShowDialog={(val: boolean) => setShowTemplateDialog(val)}
                    header={`Templates`}
                    width={'75%'}
                    height={'55%'}
                    hideDoneButton={false}
                >
                    <OperationTemplate isWorkorderSide order_detail={order_detail} />
                </GlobalDialog>
            ) : null}
            <>
                {hideAddDialog ? (
                    <GlobalDialog
                        showDialog={hideAddDialog}
                        setShowDialog={(val) => setHideAddDialog(val)}
                        header='Order Attachments'
                        width={'75%'}
                        height={'55%'}
                        hideDoneButton={false}
                    >
                        <OrderAttachments outter_order_code={currentWOC} />
                    </GlobalDialog>
                ) : null}
            </>
            {massiveEditDialog ? (
                <MassiveOrderEdit
                    title='Edit'
                    isEditingOrder={true}
                    callback={massCallBack}
                    massiveEditDialog={massiveEditDialog}
                    setMassiveEditDialog={(val: boolean) => setMassiveEditDialog(val)}
                />
            ) : null}
            {hideShiftDialog ? <GlobalDialog
                showDialog={hideShiftDialog}
                setShowDialog={(val: boolean) => setHideShiftDialog(val)}
                header={`Confirm Shift Assign`}
                width={'250px'}
                hideDoneButton={true}
                buttons={buttonShiftAssignment}
            >
                <GlobalDropDown
                    id='cloudplanner-operations-shift'
                    placeHolder='Shift'
                    url='shift/Shift'
                    field={{ text: 'rosterCode', value: 'rosterId' }}
                    refDD={(scope: DropDownListComponent) =>
                        (dropDownListObjectShiftElment = scope)
                    }
                    itemTemplate={itemTemplateShiftColor}
                    floatLabelType='Always'
                    actionComplete={onShiftActionComplete}
                />
            </GlobalDialog> : null}
            {hideTeamDialog &&
                <GlobalDialog
                    showDialog={hideTeamDialog}
                    setShowDialog={(val: boolean) => setHideTeamDialog(val)}
                    header={`Confirm Team Assign`}
                    width={'250px'}
                    hideDoneButton={true}
                    buttons={buttonTeamAssignment}
                >
                    <GlobalDropDown
                        id='cloudplanner-operations-team'
                        placeHolder='Team'
                        url='team'
                        field={{ text: 'team_code', value: 'team_id' }}
                        refDD={(scope: DropDownListComponent) =>
                            (dropDownListObjectTeamElment = scope)
                        }
                        floatLabelType='Always'
                        actionComplete={onTeamActionComplete}
                    />
                </GlobalDialog>
            }
            {hideSchedulerTimeDialog ? (
                <GlobalDialog
                    showDialog={hideSchedulerTimeDialog}
                    setShowDialog={(val) =>
                        setHideSchedulerTimeDialog(val)
                    }
                    header='Confirm Scheduler'
                    width={'350px'}
                    hideDoneButton={true}
                    buttons={buttonScheduler}
                >
                    <DateTimePickerComponent
                        placeholder='Select a range'
                        change={confirmSchedulerTime.bind(this)}
                        format={'dd/MM/yyyy HH:mm'}
                        value={defaultConfirmScheduleDate}
                        ref={(scope: DateTimePickerComponent) =>
                            (dateTimePicker = scope)
                        }
                    />
                </GlobalDialog>
            ) : null}
            {hideDialogEventPlan ? (
                <AssignWorkOrderDialog
                    hideDialogEventPlan={hideDialogEventPlan}
                    selectedOrders={gridCPWorkorder?.getSelectedRecords()}
                    setHideDialogEventPlan={(val: boolean) => {
                        setHideDialogEventPlan(val);
                        gridCPWorkorder.clearRowSelection();
                        //refreshGridFunction();
                    }}
                    theModel={theDatas}
                />
            ) : null}

            {questionDialog ? (
                <GlobalDialog
                    showDialog={questionDialog}
                    setShowDialog={(val) => setQuestionDialog(val)}
                    header='Fetch Records Message'
                    width={'20%'}
                    height={'15%'}
                    hideDoneButton={true}
                    content={'Which datas do you want to fetch?'}
                    buttons={buttonsOrder}
                ></GlobalDialog>
            ) : null}

            {commitToErpClicked ? (
                <GlobalDialog
                    showDialog={commitToErpClicked}
                    setShowDialog={(val) => setcommitToErpClicked(val)}
                    header='Commit to Erp'
                    width={'20%'}
                    height={'20%'}
                    hideDoneButton={true}
                    content={'Commit to Erp ?'}
                    buttons={commitToErpButtonModel}
                ></GlobalDialog>
            ) : null}
            { }
        </div>
    );
};
export default React.memo(WorkOrders);
